(window.theme = window.theme || {}),
  (theme.bp = {}),
  (theme.bp.smallUp = 900),
  (theme.bp.small = theme.bp.smallUp - 1),
  (theme.config = {
    cssLoaded: !1,
    bpSmall: !1,
    hasSessionStorage: !0,
    mediaQuerySmall: "screen and (max-width: " + theme.bp.small + "px)",
    mediaQuerySmallUp: "screen and (min-width: " + theme.bp.smallUp + "px)",
    youTubeReady: !1,
    vimeoReady: !1,
    vimeoLoading: !1,
    isSafari: !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/),
    isTouch: !!(
      "ontouchstart" in window ||
      (window.DocumentTouch && window.document instanceof DocumentTouch) ||
      window.navigator.maxTouchPoints ||
      window.navigator.msMaxTouchPoints
    ),
    rtl: "rtl" == document.documentElement.getAttribute("dir"),
  }),
  console &&
    console.log &&
    console.log(
      "Streamline theme (" +
        theme.settings.themeVersion +
        ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
    ),
  (window.lazySizesConfig = window.lazySizesConfig || {}),
  (lazySizesConfig.expFactor = 4),
  (function (t) {
    var t = (jQuery = t);
    (theme.utils = {
      defaultTo: function (t, e) {
        return null == t || t != t ? e : t;
      },
      promiseStylesheet: function () {
        return (
          "undefined" == typeof this.stylesheetPromise &&
            (this.stylesheetPromise = t.Deferred(function (t) {
              var e = document.querySelector(
                'link[href="' + theme.stylesheet + '"]'
              );
              e.loaded && t.resolve(),
                onloadCSS(e, function () {
                  t.resolve();
                });
            })),
          this.stylesheetPromise
        );
      },
    }),
      (theme.a11y = {
        trapFocus: function (e) {
          var i = {
            focusin: e.namespace ? "focusin." + e.namespace : "focusin",
            focusout: e.namespace ? "focusout." + e.namespace : "focusout",
            keydown: e.namespace
              ? "keydown." + e.namespace
              : "keydown.handleFocus",
          };
          var n = e.$container.find(
            t(
              'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
            ).filter(":visible")
          );
          var a = n[0];
          var o = n[n.length - 1];

          function s(t) {
            9 === t.keyCode &&
              (t.target !== o || t.shiftKey || (t.preventDefault(), a.focus()),
              t.target === a && t.shiftKey && (t.preventDefault(), o.focus()));
          }
          e.$elementToFocus || (e.$elementToFocus = e.$container),
            e.$container.attr("tabindex", "-1"),
            e.$elementToFocus.focus(),
            t(document).off("focusin"),
            t(document).on(i.focusout, function () {
              t(document).off(i.keydown);
            }),
            t(document).on(i.focusin, function (e) {
              (e.target !== o && e.target !== a) ||
                t(document).on(i.keydown, function (t) {
                  s(t);
                });
            });
        },
        removeTrapFocus: function (e) {
          var i = e.namespace ? "focusin." + e.namespace : "focusin";
          e.$container &&
            e.$container.length &&
            e.$container.removeAttr("tabindex"),
            t(document).off(i);
        },
        lockMobileScrolling: function (e, i) {
          if (i) var n = i;
          else var n = t(document.documentElement).add("body");
          n.on("touchmove" + e, function () {
            return !1;
          });
        },
        unlockMobileScrolling: function (e, i) {
          if (i) var n = i;
          else var n = t(document.documentElement).add("body");
          n.off(e);
        },
        promiseAnimationEnd: function (e) {
          var i = "animationend webkitAnimationEnd oAnimationEnd";
          var n = [
            "animation-duration",
            "-moz-animation-duration",
            "-webkit-animation-duration",
            "-o-animation-duration",
          ];
          var a = 0;
          var o = t.Deferred().resolve();
          return (
            t.each(n, function (t, i) {
              a || (a = parseFloat(e.css(i)));
            }),
            a > 0 &&
              (o = t.Deferred(function (t) {
                e.on(i, function (n) {
                  n.target === e[0] && (e.off(i), t.resolve());
                });
              })),
            o
          );
        },
        promiseTransitionEnd: function (e) {
          var i =
            "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend";
          var n = [
            "transition-duration",
            "-moz-transition-duration",
            "-webkit-transition-duration",
            "-o-transition-duration",
          ];
          var a = 0;
          var o = t.Deferred().resolve();
          return (
            t.each(n, function (t, i) {
              a || (a = parseFloat(e.css(i)));
            }),
            a > 0 &&
              (o = t.Deferred(function (t) {
                e.on(i, function (n) {
                  n.target === e[0] && (e.off(i), t.resolve());
                });
              })),
            o
          );
        },
      }),
      (theme.Sections = function e() {
        (this.constructors = {}),
          (this.instances = []),
          t(document)
            .on("shopify:section:load", this._onSectionLoad.bind(this))
            .on("shopify:section:unload", this._onSectionUnload.bind(this))
            .on("shopify:section:select", this._onSelect.bind(this))
            .on("shopify:section:deselect", this._onDeselect.bind(this))
            .on("shopify:block:select", this._onBlockSelect.bind(this))
            .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
      }),
      (theme.Sections.prototype = t.extend({}, theme.Sections.prototype, {
        createInstance: function (e, i, n) {
          var a = t(e);
          var o = a.attr("data-section-id");
          var s = a.attr("data-section-type");
          if ("undefined" != typeof (i = i || this.constructors[s])) {
            var r;
            if (n) if (this._findInstance(o)) return;
            var c = t.extend(new i(e), {
              id: o,
              type: s,
              container: e,
              namespace: "." + s + "-" + o,
            });
            this.instances.push(c);
          }
        },
        _onSectionLoad: function (e, i, n) {
          AOS && AOS.refreshHard();
          var a = i || t("[data-section-id]", e.target)[0];
          if (a) {
            this.createInstance(a);
            var o = i ? n : this._findInstance(e.detail.sectionId);
            i || this.loadSubSections(),
              o && "function" == typeof o.onLoad && o.onLoad(e);
          }
        },
        loadSubSections: function (e) {
          var i;
          (e ? e.find("[data-subsection]") : t("[data-subsection]")).each(
            function (e, i) {
              this._onSectionLoad(null, i, t(i).data("section-id"));
            }.bind(this)
          ),
            AOS && AOS.refreshHard();
        },
        _onSectionUnload: function (t) {
          var e = this._removeInstance(t.detail.sectionId);
          e && "function" == typeof e.onUnload && e.onUnload(t);
        },
        _onSelect: function (t) {
          var e = this._findInstance(t.detail.sectionId);
          e && "function" == typeof e.onSelect && e.onSelect(t);
        },
        _onDeselect: function (t) {
          var e = this._findInstance(t.detail.sectionId);
          e && "function" == typeof e.onDeselect && e.onDeselect(t);
        },
        _onBlockSelect: function (t) {
          var e = this._findInstance(t.detail.sectionId);
          e && "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        },
        _onBlockDeselect: function (t) {
          var e = this._findInstance(t.detail.sectionId);
          e && "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
        },
        _findInstance: function (t) {
          for (var e = 0; e < this.instances.length; e++)
            if (this.instances[e].id === t) return this.instances[e];
        },
        _removeInstance: function (t) {
          var e = this.instances.length;
          var i;
          while (e--)
            if (this.instances[e].id === t) {
              (i = this.instances[e]), this.instances.splice(e, 1);
              break;
            }
          return i;
        },
        reinitSection: function (t) {
          for (var e = 0; e < sections.instances.length; e++) {
            var i = sections.instances[e];
            i["type"] === t &&
              "function" == typeof i.forceReload &&
              i.forceReload();
          }
        },
        register: function (e, i, n) {
          var a = !1;
          this.constructors[e] = i;
          var o = t("[data-section-type=" + e + "]");
          n && (o = t("[data-section-type=" + e + "]", n)),
            o.each(
              function (t, e) {
                this.createInstance(e, i, n);
              }.bind(this)
            );
        },
      })),
      (theme.Currency = (function () {
        var t = "${{amount}}";

        function e(e, i) {
          "string" == typeof e && (e = e.replace(".", ""));
          var n = "";
          var a = /\{\{\s*(\w+)\s*\}\}/;
          var o = i || t;

          function s(t, e, i, n) {
            if (
              ((e = theme.utils.defaultTo(e, 2)),
              (i = theme.utils.defaultTo(i, ",")),
              (n = theme.utils.defaultTo(n, ".")),
              isNaN(t) || null == t)
            )
              return 0;
            var a = (t = (t / 100).toFixed(e)).split(".");
            var o;
            var s;
            return (
              a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
              (a[1] ? n + a[1] : "")
            );
          }
          switch (o.match(a)[1]) {
            case "amount":
              n = s(e, 2);
              break;
            case "amount_no_decimals":
              n = s(e, 0);
              break;
            case "amount_with_comma_separator":
              n = s(e, 2, ".", ",");
              break;
            case "amount_no_decimals_with_comma_separator":
              n = s(e, 0, ".", ",");
              break;
            case "amount_no_decimals_with_space_separator":
              n = s(e, 0, " ");
              break;
          }
          return o.replace(a, n);
        }

        function i(t) {
          if (
            t &&
            t.unit_price_measurement &&
            t.unit_price_measurement.reference_value
          )
            return 1 === t.unit_price_measurement.reference_value
              ? t.unit_price_measurement.reference_unit
              : t.unit_price_measurement.reference_value +
                  t.unit_price_measurement.reference_unit;
        }
        return {
          formatMoney: e,
          getBaseUnit: i,
        };
      })()),
      (theme.Images = (function () {
        function t(t) {
          if (!t) return "620x";
          var e = t.match(
            /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
          );
          return null !== e ? e[1] : null;
        }

        function e(t, e) {
          if (null == e) return t;
          if ("master" === e) return this.removeProtocol(t);
          var i = t.match(
            /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
          );
          if (null != i) {
            var n = t.split(i[0]);
            var a = i[0];
            return this.removeProtocol(n[0] + "_" + e + a);
          }
          return null;
        }

        function i(t) {
          return t.replace(/http(s)?:/, "");
        }
        return {
          imageSize: t,
          getSizedImageUrl: e,
          removeProtocol: i,
        };
      })()),
      (theme.Variants = (function () {
        function e(e) {
          (this.$container = e.$container),
            (this.variants = e.variants),
            (this.singleOptionSelector = e.singleOptionSelector),
            (this.originalSelectorId = e.originalSelectorId),
            (this.enableHistoryState = e.enableHistoryState),
            (this.currentVariant = this._getVariantFromOptions()),
            t(this.singleOptionSelector, this.$container).on(
              "change",
              this._onSelectChange.bind(this)
            );
        }
        return (
          (e.prototype = t.extend({}, e.prototype, {
            _getCurrentOptions: function () {
              var e = t.map(
                t(this.singleOptionSelector, this.$container),
                function (e) {
                  var i = t(e);
                  var n = i.attr("type");
                  var a = {};
                  return "radio" === n || "checkbox" === n
                    ? !!i[0].checked &&
                        ((a.value = i.val()), (a.index = i.data("index")), a)
                    : ((a.value = i.val()), (a.index = i.data("index")), a);
                }
              );
              return (e = this._compact(e));
            },
            _getVariantFromOptions: function () {
              var t = this._getCurrentOptions();
              var e = this.variants;
              var i = !1;
              return (
                e.forEach(function (e) {
                  var n = !0;
                  var a = e.options;
                  t.forEach(function (t) {
                    n && (n = e[t.index] === t.value);
                  }),
                    n && (i = e);
                }),
                i || null
              );
            },
            _onSelectChange: function () {
              var t = this._getVariantFromOptions();
              this.$container.trigger({
                type: "variantChange",
                variant: t,
              }),
                document.dispatchEvent(
                  new CustomEvent("variant:change", {
                    detail: {
                      variant: t,
                    },
                  })
                ),
                t &&
                  (this._updateMasterSelect(t),
                  this._updateImages(t),
                  this._updatePrice(t),
                  this._updateUnitPrice(t),
                  this._updateSKU(t),
                  (this.currentVariant = t),
                  this.enableHistoryState && this._updateHistoryState(t));
            },
            _updateImages: function (t) {
              var e = t.featured_image || {};
              var i = this.currentVariant.featured_image || {};
              t.featured_image &&
                e.src !== i.src &&
                this.$container.trigger({
                  type: "variantImageChange",
                  variant: t,
                });
            },
            _updatePrice: function (t) {
              (t.price === this.currentVariant.price &&
                t.compare_at_price === this.currentVariant.compare_at_price) ||
                this.$container.trigger({
                  type: "variantPriceChange",
                  variant: t,
                });
            },
            _updateUnitPrice: function (t) {
              t.unit_price !== this.currentVariant.unit_price &&
                this.$container.trigger({
                  type: "variantUnitPriceChange",
                  variant: t,
                });
            },
            _updateSKU: function (t) {
              t.sku !== this.currentVariant.sku &&
                this.$container.trigger({
                  type: "variantSKUChange",
                  variant: t,
                });
            },
            _updateHistoryState: function (t) {
              if (history.replaceState && t) {
                var e =
                  window.location.protocol +
                  "//" +
                  window.location.host +
                  window.location.pathname +
                  "?variant=" +
                  t.id;
                window.history.replaceState(
                  {
                    path: e,
                  },
                  "",
                  e
                );
              }
            },
            _updateMasterSelect: function (e) {
              t(this.originalSelectorId, this.$container).val(e.id);
            },
            _compact: function (t) {
              var e = -1,
                i = null == t ? 0 : t.length,
                n = 0,
                a = [];
              while (++e < i) {
                var o = t[e];
                o && (a[n++] = o);
              }
              return a;
            },
          })),
          e
        );
      })()),
      (theme.rte = {
        init: function () {
          theme.rte.wrapTable(), theme.rte.wrapVideo(), theme.rte.imageLinks();
        },
        wrapTable: function () {
          t(".rte table").wrap('<div class="table-wrapper"></div>');
        },
        wrapVideo: function () {
          var e = t(
            '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
          );
          var i = e.add("iframe#admin_bar_iframe");
          e.each(function () {
            t(this).parents(".video-wrapper").length ||
              t(this).wrap('<div class="video-wrapper"></div>');
          }),
            i.each(function () {
              this.src = this.src;
            });
        },
        imageLinks: function () {
          t(".rte a img").parent().addClass("rte__image");
        },
      }),
      (theme.LibraryLoader = (function () {
        var t = {
          link: "link",
          script: "script",
        };
        var e = {
          requested: "requested",
          loaded: "loaded",
        };
        var i = "https://cdn.shopify.com/shopifycloud/";
        var n = {
          youtubeSdk: {
            tagId: "youtube-sdk",
            src: "https://www.youtube.com/iframe_api",
            type: t.script,
          },
          shopifyXr: {
            tagId: "shopify-model-viewer-xr",
            src: i + "shopify-xr-js/assets/v1.0/shopify-xr.en.js",
            type: t.script,
          },
          modelViewerUi: {
            tagId: "shopify-model-viewer-ui",
            src: i + "model-viewer-ui/assets/v1.0/model-viewer-ui.en.js",
            type: t.script,
          },
          modelViewerUiStyles: {
            tagId: "shopify-model-viewer-ui-styles",
            src: i + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
            type: t.link,
          },
        };

        function a(i, a) {
          var r = n[i];
          if (r && r.status !== e.requested) {
            if (((a = a || function () {}), r.status === e.loaded))
              return a(), void 0;
            var c;
            switch (((r.status = e.requested), r.type)) {
              case t.script:
                c = o(r, a);
                break;
              case t.link:
                c = s(r, a);
                break;
            }
            (c.id = r.tagId), (r.element = c);
            var d = document.getElementsByTagName(r.type)[0];
            d.parentNode.insertBefore(c, d);
          }
        }

        function o(t, i) {
          var n = document.createElement("script");
          return (
            (n.src = t.src),
            n.addEventListener("load", function () {
              (t.status = e.loaded), i();
            }),
            n
          );
        }

        function s(t, i) {
          var n = document.createElement("link");
          return (
            (n.href = t.src),
            (n.rel = "stylesheet"),
            (n.type = "text/css"),
            n.addEventListener("load", function () {
              (t.status = e.loaded), i();
            }),
            n
          );
        }
        return {
          load: a,
        };
      })()),
      (theme.Modals = (function () {
        function e(e, i, n) {
          var a = {
            close: ".js-modal-close",
            open: ".js-modal-open-" + i,
            openClass: "modal--is-active",
            bodyOpenClass: "modal-open",
            closeOffContentClick: !0,
          };
          if (((this.id = e), (this.$modal = t("#" + e)), !this.$modal.length))
            return !1;
          (this.nodes = {
            $parent: t("html").add("body"),
            $modalContent: this.$modal.find(".modal__inner"),
          }),
            (this.config = t.extend(a, n)),
            (this.modalIsOpen = !1),
            (this.$focusOnOpen = this.config.focusOnOpen
              ? t(this.config.focusOnOpen)
              : this.$modal),
            this.init();
        }
        return (
          (e.prototype.init = function () {
            var e;
            t(this.config.open).attr("aria-expanded", "false"),
              t(this.config.open).on("click", this.open.bind(this)),
              this.$modal
                .find(this.config.close)
                .on("click", this.close.bind(this)),
              t("body").on(
                "drawerOpen",
                function () {
                  this.close();
                }.bind(this)
              );
          }),
          (e.prototype.open = function (e) {
            var i = !1;
            this.modalIsOpen ||
              (e ? e.preventDefault() : (i = !0),
              e &&
                e.stopPropagation &&
                (e.stopPropagation(),
                (this.$activeSource = t(e.currentTarget).attr(
                  "aria-expanded",
                  "true"
                ))),
              this.modalIsOpen && !i && this.close(),
              this.$modal.addClass(this.config.openClass),
              this.nodes.$parent.addClass(this.config.bodyOpenClass),
              setTimeout(
                function () {
                  this.$modal.addClass("aos-animate");
                }.bind(this),
                0
              ),
              (this.modalIsOpen = !0),
              theme.a11y.trapFocus({
                $container: this.$modal,
                $elementToFocus: this.$focusOnOpen,
                namespace: "modal_focus",
              }),
              t("body").trigger("modalOpen." + this.id),
              this.bindEvents());
          }),
          (e.prototype.close = function () {
            this.modalIsOpen &&
              (t(document.activeElement).trigger("blur"),
              this.$modal
                .removeClass(this.config.openClass)
                .removeClass("aos-animate"),
              this.nodes.$parent.removeClass(this.config.bodyOpenClass),
              (this.modalIsOpen = !1),
              theme.a11y.removeTrapFocus({
                $container: this.$modal,
                namespace: "modal_focus",
              }),
              this.$activeSource &&
                this.$activeSource.attr("aria-expanded") &&
                this.$activeSource.attr("aria-expanded", "false").focus(),
              t("body").trigger("modalClose." + this.id),
              this.unbindEvents());
          }),
          (e.prototype.bindEvents = function () {
            this.nodes.$parent.on(
              "keyup.modal",
              function (t) {
                27 === t.keyCode && this.close();
              }.bind(this)
            ),
              this.config.closeOffContentClick &&
                (this.$modal.on("click.modal", this.close.bind(this)),
                this.nodes.$modalContent.on("click.modal", function (t) {
                  t.stopImmediatePropagation();
                }));
          }),
          (e.prototype.unbindEvents = function () {
            this.nodes.$parent.off(".modal"),
              this.config.closeOffContentClick &&
                (this.$modal.off(".modal"),
                this.nodes.$modalContent.off(".modal"));
          }),
          e
        );
      })()),
      (theme.ProductScreen = (function () {
        var e = document.title;
        var i = "productscreen";
        var n = 0;
        var a = t("#MainContent");

        function o(e, i, n) {
          var a = {
            close: ".js-screen-close",
            open: ".js-screen-open-" + i,
            openClass: "screen-layer--is-active",
            closeSlideAnimate: "screen-layer--is-sliding",
            bodyOpenClass: "screen-layer-open",
            bodyClosingClass: "screen-layer-closing",
            bodyCloseAnimate: "screen-layer-closing screen-layer-animating",
            loaderStart: 200,
            pullToCloseThreshold: -100,
          };
          if (
            ((this.id = e),
            (this.$screen = t("#" + e)),
            (this.title = this.$screen.data("product-title")),
            !this.$screen.length)
          )
            return !1;
          (this.nodes = {
            $parent: t("html").add("body"),
            $body: t("body"),
            $loader: t("#OverscrollLoader").find(".icon-loader__path"),
            $screenContent: this.$screen.find(".screen-layer__inner"),
            $photoswipe: t(".pswp"),
          }),
            (this.config = t.extend(a, n)),
            (this.initalized = !1),
            (this.isOpen = !1),
            (this.$focusOnOpen = this.config.focusOnOpen
              ? t(this.config.focusOnOpen)
              : this.$screen),
            this.init();
        }
        return (
          (o.prototype.init = function () {
            var e;
            t(this.config.open).attr("aria-expanded", "false"),
              t("body").on("click", this.config.open, this.open.bind(this)),
              this.$screen.find(this.config.close).on(
                "click",
                {
                  noAnimate: !0,
                  back: !0,
                },
                this.close.bind(this)
              ),
              "sticky" === theme.settings.cartType &&
                (this.nodes.$body.on(
                  "added." + this.id,
                  function () {
                    theme.headerNav.toggleThumbMenu(!1, !0);
                    var t = {
                      back: !0,
                    };
                    this.close(!1, t);
                  }.bind(this)
                ),
                this.nodes.$body.on(
                  "error." + this.id,
                  function () {
                    this.initalized && this.open();
                  }.bind(this)
                ));
          }),
          (o.prototype.open = function (e, a) {
            var o = !1;
            var s = {
              updateCurrentPath: !a || a.updateCurrentPath,
            };
            if (!this.isOpen) {
              e ? e.preventDefault() : (o = !0),
                e &&
                  e.stopPropagation &&
                  (e.stopPropagation(),
                  (this.$activeSource = t(e.currentTarget))),
                this.isOpen && !o && this.close(),
                (n = window.scrollY),
                this.$screen
                  .prepareTransition()
                  .addClass(this.config.openClass),
                this.nodes.$parent.addClass(this.config.bodyOpenClass),
                (function() { if (window.innerWidth <= 900) { var m = document.querySelector('.site-nav__thumb-menu'); if (m) m.style.setProperty('display', 'none', 'important'); } })(),
                this.nodes.$screenContent.scrollTop(0),
                window.scrollTo(0, 0),
                theme.a11y.trapFocus({
                  $container: this.$screen,
                  $elementToFocus: this.$focusOnOpen,
                  namespace: i,
                }),
                this.$activeSource &&
                  this.$activeSource.attr("aria-expanded") &&
                  this.$activeSource.attr("aria-expanded", "true");
              var r = this.$activeSource.data("url");
              this.nodes.$body
                .trigger("productModalOpen." + this.id)
                .trigger("newPopstate", {
                  screen: this,
                  url: r,
                  updateCurrentPath: s.updateCurrentPath,
                }),
                (this.initalized = !0),
                (this.isOpen = !0),
                (document.title = this.title),
                window.ga &&
                  ga("send", "pageview", {
                    page: r,
                  }),
                this.bindEvents();
            }
          }),
          (o.prototype.close = function (a, o) {
            var s = o || (a ? a.data : null);
            var r = !!s && s.back;
            var c = !(!s || !s.noAnimate);
            this.nodes.$body.removeAttr("style"),
              this.nodes.$loader.css(
                "stroke-dashoffset",
                this.config.loaderStart
              ),
              r &&
                this.nodes.$body.trigger("newPopstate", {
                  screen: this,
                  back: !0,
                });
            var d = c ? "" : this.config.closeSlideAnimate;
            var l = c
              ? this.config.bodyClosingClass
              : this.config.bodyCloseAnimate;
            this.isOpen &&
              (t(document.activeElement).trigger("blur"),
              this.$screen
                .prepareTransition()
                .removeClass(this.config.openClass)
                .addClass(d),
              this.nodes.$parent
                .removeClass(this.config.bodyOpenClass)
                .addClass(l),
              (function() { var m = document.querySelector('.site-nav__thumb-menu'); if (m) m.style.removeProperty('display'); })(),
              window.setTimeout(
                function () {
                  this.$screen.removeClass(d),
                    this.nodes.$parent.removeClass(l),
                    window.scrollTo(0, n);
                }.bind(this),
                500
              ),
              theme.a11y.removeTrapFocus({
                $container: this.$screen,
                namespace: i,
              }),
              this.$activeSource &&
                this.$activeSource.attr("aria-expanded") &&
                this.$activeSource.attr("aria-expanded", "false").focus(),
              this.nodes.$body
                .trigger("productModalClose")
                .trigger("productModalClose." + this.id),
              window.scrollTo(0, n),
              (this.isOpen = !1),
              (document.title = e),
              window.ga && ga("send", "pageview"),
              this.unbindEvents());
          }),
          (o.prototype.bindEvents = function () {
            this.nodes.$body.on(
              "keyup." + i,
              function (t) {
                if (27 === t.keyCode) {
                  if (this.nodes.$photoswipe.hasClass("pswp--open")) return;
                  if (this.nodes.$body.hasClass("js-drawer-open")) return;
                  var e = {
                    back: !0,
                  };
                  this.close(!1, e);
                }
              }.bind(this)
            );
            var e = 0;
            var n = 0;
            t(document).on(
              "touchmove." + i,
              t.throttle(
                15,
                function (t) {
                  var i = window.scrollY;
                  i >= 0 ||
                    ((e = -i / 100),
                    this.nodes.$body.css("background", "rgba(0,0,0," + e + ")"),
                    (n = this.config.loaderStart + 2 * i),
                    i <= this.config.pullToCloseThreshold && (n = 0),
                    this.nodes.$loader.css("stroke-dashoffset", n));
                }.bind(this)
              )
            ),
              t(document).on(
                "touchend." + i,
                function (t) {
                  var e;
                  if (
                    ((totalLoader = this.config.loaderStart),
                    window.scrollY < this.config.pullToCloseThreshold)
                  ) {
                    var i = {
                      back: !0,
                    };
                    this.close(!1, i);
                  }
                }.bind(this)
              );
          }),
          (o.prototype.unbindEvents = function () {
            this.nodes.$body.off("." + i), t(document).off("." + i);
          }),
          o
        );
      })()),
      (theme.Drawers = (function () {
        function e(e, i) {
          if (
            ((this.config = {
              id: e,
              close: ".js-drawer-close",
              open: ".js-drawer-open-" + i,
              openClass: "js-drawer-open",
              closingClass: "js-drawer-closing",
              activeDrawer: "drawer--is-open",
              namespace: ".drawer-" + i,
            }),
            (this.$nodes = {
              parent: t(document.documentElement).add("body"),
              page: t("body"),
            }),
            (this.$drawer = t("#" + e)),
            !this.$drawer.length)
          )
            return !1;
          (this.isOpen = !1), this.init();
          $(document).on("submit", ".upsell-form", function (e) {
            e.preventDefault();
            var form = $(this);
            var a = $(this).serialize();
            var atc = theme.cart.addItemFromForm(a);
            $(".quick-view-box").hide();
            $("body").removeClass("overflow-fixed");
            $("html").removeClass("overflow-fixed");
            setTimeout(function () {
              form.find(".atc-text").text("ADDED");
            }, 1000);
            setTimeout(function () {
              form.find(".atc-text").text("ADD TO CART");
            }, 3000);
          });
          // $(document).on('submit','.upsell-form',function(e){
          //   e.preventDefault();
          //   var a=$(this).serialize();
          //   theme.cart.addItemFromForm(a);
          // });
        }
        return (
          (e.prototype = t.extend({}, e.prototype, {
            init: function () {
              var e = t(this.config.open);
              e.attr("aria-expanded", "false"),
                e.on("click", this.open.bind(this)),
                this.$drawer
                  .find(this.config.close)
                  .on("click", this.close.bind(this));
            },
            open: function (e, i) {
              if ((e && e.preventDefault(), !this.isOpen)) {
                if (e && e.stopPropagation)
                  e.stopPropagation(),
                    (this.$activeSource = t(e.currentTarget).attr(
                      "aria-expanded",
                      "true"
                    ));
                else if (i) {
                  var n = t(i);
                  this.$activeSource = n.attr("aria-expanded", "true");
                }
                this.$drawer
                  .prepareTransition()
                  .addClass(this.config.activeDrawer),
                  this.$nodes.parent.addClass(this.config.openClass),
                  (this.isOpen = !0),
                  theme.a11y.trapFocus({
                    $container: this.$drawer,
                    namespace: "drawer_focus",
                  }),
                  t("body").trigger("drawerOpen." + this.config.id),
                  this.bindEvents();
              }
            },
            close: function () {
              this.isOpen &&
                (t(document.activeElement).trigger("blur"),
                this.$drawer
                  .prepareTransition()
                  .removeClass(this.config.activeDrawer),
                this.$nodes.parent.removeClass(this.config.openClass),
                this.$nodes.parent.addClass(this.config.closingClass),
                window.setTimeout(
                  function () {
                    this.$nodes.parent.removeClass(this.config.closingClass),
                      this.$activeSource &&
                        this.$activeSource.attr("aria-expanded") &&
                        this.$activeSource
                          .attr("aria-expanded", "false")
                          .focus();
                  }.bind(this),
                  500
                ),
                (this.isOpen = !1),
                theme.a11y.removeTrapFocus({
                  $container: this.$drawer,
                  namespace: "drawer_focus",
                }),
                this.unbindEvents());
            },
            bindEvents: function () {
              theme.a11y.lockMobileScrolling(
                this.config.namespace,
                this.$nodes.page
              ),
                this.$nodes.page.on(
                  "click" + this.config.namespace,
                  function (t) {
                    if (t.target === this.$nodes.page[0])
                      return this.close(), !1;
                  }.bind(this)
                ),
                this.$nodes.parent.on(
                  "keyup" + this.config.namespace,
                  function (t) {
                    27 === t.keyCode && this.close();
                  }.bind(this)
                );
            },
            unbindEvents: function () {
              theme.a11y.unlockMobileScrolling(
                this.config.namespace,
                this.$nodes.page
              ),
                this.$nodes.parent.off(this.config.namespace),
                this.$nodes.page.off(this.config.namespace);
            },
          })),
          e
        );
      })()),
      (theme.cart = {
        getCart: function () {
          return t.getJSON(theme.routes.cart);
        },
        changeItem: function (t, e) {
          return this._updateCart({
            type: "POST",
            url: theme.routes.cartChange,
            data: "quantity=" + e + "&id=" + t,
            dataType: "json",
          });
        },
        addItemFromForm: function (t) {
          return this._updateCart({
            type: "POST",
            url: theme.routes.cartAdd,
            data: t,
            dataType: "json",
          });
        },
        addUpsellItem: function (t) {
          return this._updateCart({
            type: "POST",
            url: theme.routes.cartAdd,
            data: t,
            dataType: "json",
          });
        },
        _updateCart: function (e) {
          return t.ajax(e).then(
            function (e) {
              return t("body").trigger("updateCart", e), e;
            }.bind(this)
          );
        },
        updateNote: function (e) {
          var i = {
            type: "POST",
            url: "/cart/update.js",
            data: "note=" + theme.cart.attributeToString(e),
            dataType: "json",
            success: function (t) {},
            error: function (t, e) {},
          };
          t.ajax(i);
        },
        attributeToString: function (t) {
          return (
            "string" != typeof t && "undefined" === (t += "") && (t = ""),
            t.trim()
          );
        },
      }),
      t(function () {
        t("body").on("click", ".cart__checkout", function () {
          t(this).addClass("btn--loading");
        }),
          t("body").on("change", 'textarea[name="note"]', function () {
            var e = t(this).val();
            theme.cart.updateNote(e);
          }),
          t("body").on("click", ".cart__checkout--ajax", function (e) {
            if (!t("#CartAgree").is(":checked"))
              return (
                alert(theme.strings.cartTermsConfirmation),
                t(this).removeClass("btn--loading"),
                !1
              );
          }),
          t("body").on("click", ".cart__checkout--page", function (e) {
            if (!t("#CartPageAgree").is(":checked"))
              return (
                alert(theme.strings.cartTermsConfirmation),
                t(this).removeClass("btn--loading"),
                !1
              );
          });
      }),
      (theme.AjaxCart = (function () {
        var e = {
          namespace: ".ajaxcart",
        };
        var i = {
          itemId: "data-cart-item-id",
        };
        var n = {
          form: "form.cart",
          cartCount: ".cart-link__count",
          updateBtn: ".update-cart",
          itemList: "[data-cart-item-list]",
          item: "[data-cart-item]",
          itemId: "[data-cart-item-id]",
          itemHref: "[data-cart-item-href]",
          itemBackgroundImage: "[data-cart-item-background-image]",
          itemTitle: "[data-cart-item-title]",
          itemVariantTitle: "[data-cart-item-variant-title]",
          itemPropertyList: "[data-cart-item-property-list]",
          itemProperty: "[data-cart-item-property]",
          itemDiscountList: "[data-cart-item-discount-list]",
          itemDiscount: "[data-cart-item-discount]",
          itemDiscountTitle: "[data-cart-item-discount-title]",
          itemDiscountAmount: "[data-cart-item-discount-amount]",
          itemLabelQuantity: "[data-cart-item-label-quantity]",
          itemInputQuantity: "[data-cart-item-input-quantity]",
          itemDelete: "[data-cart-item-delete]",
          itemPriceContainer: "[data-cart-item-price-container]",
          itemLinePriceContainer: "[data-cart-item-line-price-container]",
          itemUnitPrice: "[data-cart-item-unit-price]",
          itemMessage: "[data-item-message]",
          itemSubscriptionName: "[data-cart-item-subscription-name]",
          cartDiscountContainer: "[data-cart-discount-container]",
          cartDiscountContent: "[data-cart-discount-content]",
          cartDiscount: "[data-cart-discount]",
          cartDiscountTitle: "[data-cart-discount-title]",
          cartDiscountAmount: "[data-cart-discount-amount]",
          cartNoteContainer: "[data-cart-note-container]",
          cartNoteInput: "[data-cart-note]",
          cartMessage: "[data-cart-message]",
          cartSubtotal: "[data-cart-subtotal]",
          cartSubmit: "[data-cart-submit]",
        };
        var a = {
          cartHasItems: "cart-has-items",
          cartTemplate: "ajax-cart__template",
          cartItemRemove: "cart__item--remove",
          staticDrawerElement: "drawer--cart--static",
        };

        function o(e) {
          this.id = e;
          var i = (this.$container = t("#" + e));
          (this.status = {
            loaded: !1,
            loading: !1,
            isDrawer: i.attr("data-drawer"),
          }),
            this.status.isDrawer &&
              (this.drawer = new theme.Drawers(e, "cart")),
            this.init(),
            this.initEventListeners();
        }
        return (
          (o.prototype = t.extend({}, o.prototype, {
            init: function () {
              (this.$form = t(n.form, this.$container)),
                t(n.updateBtn, this.$form).addClass("hide"),
                (this.$itemTemplate = t(n.item, this.$form).first().clone()),
                (this.$propertyTemplate = t(n.itemProperty, this.$form)
                  .first()
                  .clone()),
                (this.$discountTemplate = t(n.itemDiscount, this.$form)
                  .first()
                  .clone()),
                (this.$cartDiscountTemplate = t(n.cartDiscount, this.$container)
                  .first()
                  .clone());
            },
            initEventListeners: function () {
              t("body").on(
                "updateCart",
                function (t, e) {
                  theme.cart.getCart().then(
                    function (t) {
                      this.buildCart(t), this.updateCartNotification(t);
                      var e = !1;
                      this.status.isDrawer && (this.drawer.open(), (e = !0));
                    }.bind(this)
                  );
                }.bind(this)
              ),
                this.$container.on(
                  "click",
                  n.itemDelete,
                  this._onItemDelete.bind(this)
                ),
                this.$container.on(
                  "change",
                  n.itemInputQuantity,
                  t.debounce(500, this._onItemQuantityChange.bind(this))
                ),
                this.$container.on(
                  "input",
                  n.itemInputQuantity,
                  t.debounce(500, this._onItemQuantityChange.bind(this))
                ),
                this.$container.on(
                  "blur",
                  n.itemInputQuantity,
                  this._onItemQuantityEmptyBlur.bind(this)
                ),
                this.$container.on(
                  "focus",
                  n.itemInputQuantity,
                  this._highlightText
                );
            },
            buildCart: function (t, e) {
              console.log("here");
              console.log(t);
              if (
                (this.loading(!0),
                this.$form.removeClass("cart--empty"),
                $("#CartDrawer").removeClass("empty--drawer"),
                $(".footer-form").removeClass("cart--empty"),
                $(".upsell-products").removeClass("cart--empty"),
                0 === t.item_count)
              )
                return (
                  this.$form.addClass("cart--empty"),
                  $("#CartDrawer").addClass("empty--drawer"),
                  $(".footer-form").addClass("cart--empty"),
                  $(".upsell-products").addClass("cart--empty"),
                  (this.status.loaded = !0),
                  this.loading(!1),
                  void 0
                );
              t.items.length > 2
                ? this.$container.removeClass(a.staticDrawerElement)
                : this.$container.addClass(a.staticDrawerElement);
              var i = this._createCart(t);
              morphdom(this.$form[0], i[0]),
                Shopify &&
                  Shopify.StorefrontExpressButtons &&
                  Shopify.StorefrontExpressButtons.initialize(),
                this.status.isDrawer && !0 === e && this.drawer.open(),
                (this.status.loaded = !0),
                this.loading(!1),
                document.dispatchEvent(
                  new CustomEvent("cart:updated", {
                    detail: {
                      cart: t,
                    },
                  })
                );
            },
            _createCart: function (e) {
              var i = this.$form.clone();
              return (
                t(n.item, i).not(n.cartNoteContainer).remove(),
                t(n.itemList, i).prepend(this._createItemList(e)),
                t(n.cartNoteInput, i).val(e.note),
                t(n.cartDiscountContainer, i).toggleClass(
                  "hide",
                  0 === e.cart_level_discount_applications.length
                ),
                t(n.cartDiscountContent, i).html(
                  this._createCartDiscountList(e)
                ),
                t(n.cartSubtotal, i).html(
                  theme.Currency.formatMoney(
                    e.total_price,
                    theme.settings.moneyFormat
                  )
                ),
                $(".cart-bottom-original").html(
                  theme.Currency.formatMoney(
                    e.original_total_price,
                    theme.settings.moneyFormat
                  )
                ),
                $(".cart-bottom-total").html(
                  theme.Currency.formatMoney(
                    e.total_price,
                    theme.settings.moneyFormat
                  )
                ),
                t(n.cartSubmit, i).attr("disabled", 0 === e.items.length),
                i
              );
            },
            _createItemList: function (e) {
              return t.map(
                e.items,
                function (e) {
                  var o = this.$itemTemplate
                    .clone()
                    .removeClass(a.cartTemplate);
                  var s = this._createPropertyList(e);
                  var r = this._createDiscountList(e);
                  var c = this._createUnitPrice(e);
                  var d = this._createItemPrice(
                    e.original_price,
                    e.final_price
                  );
                  var l = this._createItemPrice(
                    e.original_line_price,
                    e.final_line_price
                  );
                  o.find(n.itemId).addBack(n.itemId).attr(i.itemId, e.key),
                    t(n.itemHref, o).attr("href", e.url),
                    t(n.itemBackgroundImage, o)
                      .removeAttr("data-bgset")
                      .css(
                        "background-image",
                        e.image
                          ? "url(" +
                              theme.Images.getSizedImageUrl(e.image, "200x") +
                              ")"
                          : "none"
                      )
                      .addClass("lazyload"),
                    t(n.itemTitle, o).text(e.product_title),
                    t(n.itemVariantTitle, o).text(
                      e.vendor.slice(0, 17) + "..."
                    ),
                    t(n.itemPriceContainer, o).html(d),
                    t(n.itemLinePriceContainer, o).html(l),
                    t(n.itemLinePrice, o).html(
                      theme.Currency.formatMoney(
                        e.line_price,
                        theme.settings.moneyFormat
                      )
                    ),
                    t(n.itemLabelQuantity, o).attr("for", "quantity_" + e.key),
                    t(n.itemInputQuantity, o)
                      .attr("data-id", e.key)
                      .attr("id", "quantity_" + e.key)
                      .val(e.quantity);
                  var h = e.selling_plan_allocation
                    ? e.selling_plan_allocation.selling_plan.name
                    : null;
                  return (
                    t(n.itemSubscriptionName, o).text(h),
                    t(n.itemPropertyList, o).html(s),
                    t(n.itemDiscountList, o).html(r),
                    t(n.itemUnitPrice, o).html(c),
                    o[0]
                  );
                }.bind(this)
              );
            },
            _createItemPrice: function (t, e) {
              return t !== e
                ? '<span class="visually-hidden">' +
                    theme.strings.regularPrice +
                    "</span>" +
                    '<del class="cart__item-price--original">' +
                    theme.Currency.formatMoney(t, theme.settings.moneyFormat) +
                    "</del>" +
                    '<span class="visually-hidden">' +
                    theme.strings.salePrice +
                    "</span>" +
                    '<span class="cart__item-price cart__item-price--bold">' +
                    theme.Currency.formatMoney(e, theme.settings.moneyFormat) +
                    "</span>"
                : '<span class="cart__item-price">' +
                    theme.Currency.formatMoney(t, theme.settings.moneyFormat) +
                    "</span>";
            },
            _createPropertyList: function (e) {
              return t.map(
                e.properties,
                function (t, e) {
                  var i = this.$propertyTemplate
                    .clone()
                    .removeClass(a.cartTemplate);
                  if ("_" !== e.charAt(0) && "" !== t)
                    return (
                      -1 === t.indexOf("/uploads/")
                        ? i.text(e + ": " + t)
                        : i.html(
                            e +
                              ': <a href="' +
                              t +
                              '">' +
                              t.split("/").pop() +
                              "</a>"
                          ),
                      i[0]
                    );
                }.bind(this)
              );
            },
            _createDiscountList: function (e) {
              return t.map(
                e.line_level_discount_allocations,
                function (t) {
                  var e = this.$discountTemplate
                    .clone()
                    .removeClass(a.cartTemplate);
                  return (
                    e
                      .find(n.itemDiscountTitle)
                      .text(t.discount_application.title),
                    e
                      .find(n.itemDiscountAmount)
                      .html(
                        theme.Currency.formatMoney(
                          t.amount,
                          theme.settings.moneyFormat
                        )
                      ),
                    e[0]
                  );
                }.bind(this)
              );
            },
            _createCartDiscountList: function (e) {
              return t.map(
                e.cart_level_discount_applications,
                function (t) {
                  var e = this.$cartDiscountTemplate
                    .clone()
                    .removeClass(a.cartTemplate);
                  return (
                    e.find(n.cartDiscountTitle).text(t.title),
                    e
                      .find(n.cartDiscountAmount)
                      .html(
                        theme.Currency.formatMoney(
                          t.total_allocated_amount,
                          theme.settings.moneyFormat
                        )
                      ),
                    e[0]
                  );
                }.bind(this)
              );
            },
            _createUnitPrice: function (t) {
              var e;
              var i;
              return (
                theme.Currency.formatMoney(
                  t.unit_price,
                  theme.settings.moneyFormat
                ) +
                "/" +
                theme.Currency.getBaseUnit(t)
              );
            },
            _onItemQuantityChange: function (e) {
              this.loading(!0);
              var a = t(e.target);
              var o = a.closest(n.item).attr(i.itemId);
              var s = a.val();
              if ("" !== s) {
                var r;
                if (0 == s)
                  if (!1 === confirm(theme.strings.cartConfirmDelete))
                    return a.val(1), this.loading(!1), void 0;
                theme.cart.changeItem(o, s);
              }
            },
            _onItemQuantityEmptyBlur: function (e) {
              var a = t(e.target);
              var o = a.closest(n.item).attr(i.itemId);
              var s;
              "" === a.val() &&
                theme.cart.getCart().then(
                  function (t) {
                    this.buildCart(t);
                  }.bind(this)
                );
            },
            _onItemDelete: function (e) {
              e.preventDefault();
              var o = t(e.target);
              var s = t(n.item, this.$container);
              var r = o.closest(n.item);
              var c = t(n.cartNoteContainer, this.$container);
              var d = r.attr(i.itemId);
              2 === s.length &&
                s.last().is(c) &&
                (c.addClass(a.cartItemRemove),
                theme.a11y
                  .promiseTransitionEnd(t(n.itemList, this.$container))
                  .then(function () {
                    c.removeClass(a.cartItemRemove);
                  })),
                r.addClass(a.cartItemRemove),
                theme.a11y.promiseAnimationEnd(r).then(
                  function () {
                    theme.cart.changeItem(d, 0);
                  }.bind(this)
                );
            },
            loading: function (e) {
              (this.status.loading = e),
                e
                  ? t(n.itemList, this.$form).addClass("loading")
                  : t(n.itemList, this.$form).removeClass("loading");
            },
            updateCartNotification: function (e) {
              t(n.cartCount).text(e.item_count),
                $(".cart-item-count").text(e.item_count),
                t("body").toggleClass(a.cartHasItems, e.item_count > 0);
            },
            _highlightText: function (e) {
              theme.config.isTouch || t(e.target).select();
            },
          })),
          o
        );
      })()),
      (theme.StickyCart = (function () {
        var e = {
          namespace: ".ajaxcart",
        };
        var i = {
          cart: "#StickyCart",
          items: "#StickyItems",
          subtotal: "#StickySubtotal",
          submit: "#StickySubmit",
        };
        var n = {
          cartTemplate: "template-cart",
          active: "sticky-cart--open",
          activeBodyClass: "body--sticky-cart-open",
        };

        function a() {
          (this.status = {
            loaded: !1,
            loading: !1,
            open: t("body").hasClass(n.activeBodyClass),
          }),
            this.initEventListeners();
        }

        function o(e) {
          t("body").hasClass(n.cartTemplate) ||
            (e.item_count > 0
              ? (t("body").addClass(n.activeBodyClass),
                t(i.cart).addClass(n.active))
              : (t("body").removeClass(n.activeBodyClass),
                t(i.cart).removeClass(n.active)),
            t(i.items).text(
              theme.strings.cartItems.replace("[count]", e.item_count)
            ),
            t(i.subtotal).html(
              theme.Currency.formatMoney(
                e.total_price,
                theme.settings.moneyFormat
              )
            ));
        }
        return (
          (a.prototype = t.extend({}, a.prototype, {
            initEventListeners: function () {
              t(i.submit).on("click", function () {
                t(this).addClass("btn--loading");
              }),
                t("body").on(
                  "added.ajaxProduct",
                  function () {
                    this.hideCart(),
                      theme.cart.getCart().then(
                        function (t) {
                          this.buildCart(t, !0);
                        }.bind(this)
                      );
                  }.bind(this)
                );
            },
            hideCart: function () {
              t("body").removeClass(n.activeBodyClass),
                t(i.cart).removeClass(n.active);
            },
            showCart: function (e, a) {
              e &&
                t(i.items).text(theme.strings.cartItems.replace("[count]", e)),
                a &&
                  t(i.subtotal).html(
                    theme.Currency.formatMoney(a, theme.settings.moneyFormat)
                  ),
                t("body").addClass(n.activeBodyClass),
                t(i.cart).addClass(n.active),
                (this.status.open = !0);
            },
            buildCart: function (t, e) {
              this.loading(!0),
                (this.status.loaded = !0),
                this.loading(!1),
                !0 === e && this.showCart(t.item_count, t.total_price);
            },
            loading: function (e) {
              (this.status.loading = e),
                e
                  ? t(i.cart).addClass("is-loading")
                  : t(i.cart).removeClass("is-loading");
            },
            updateError: function (t) {
              t.responseJSON &&
                t.responseJSON.description &&
                console.warn(t.responseJSON.description);
            },
          })),
          {
            init: a,
            refresh: o,
          }
        );
      })()),
      (theme.AjaxProduct = (function () {
        var e = {
          loading: !1,
        };

        function i(t) {
          (this.$form = t),
            (this.$addToCart = this.$form.find(".add-to-cart")),
            (this.productId = t.find('[name="data-product-id"]').val()),
            this.$form.length &&
              this.$form.on("submit", this.addItemFromForm.bind(this));
        }
        return (
          (i.prototype = t.extend({}, i.prototype, {
            addItemFromForm: function (i, n) {
              // alert('test2');
              if ((i.preventDefault(), !e.loading)) {
                this.$form.find("[data-add-to-cart]").addClass("btn--loading"),
                  (e.loading = !0);
                var a = this.$form.serialize();
                console.log(a);
                t("body").trigger("added.ProductScreen-" + this.productId),
                  theme.cart
                    .addItemFromForm(a)
                    .then(
                      function (t) {
                        this.success(t);
                      }.bind(this)
                    )
                    .catch(
                      function (t) {
                        this.error(t);
                      }.bind(this)
                    )
                    .always(
                      function () {
                        (e.loading = !1),
                          this.$form
                            .find("[data-add-to-cart]")
                            .removeClass("btn--loading");
                      }.bind(this)
                    );
              }
            },
            success: function (e) {
              this.$form.find(".errors").remove(),
                t("body").trigger("added.ajaxProduct"),
                document.dispatchEvent(
                  new CustomEvent("added:ajaxProduct", {
                    detail: {
                      product: e,
                    },
                  })
                );
            },
            error: function (e) {
              this.$form.find(".errors").remove(),
                e.responseJSON &&
                  e.responseJSON.description &&
                  (console.warn(e.responseJSON.description),
                  t("body").trigger("error.ProductScreen-" + this.productId),
                  document.dispatchEvent(
                    new CustomEvent("error:ajaxProduct", {
                      detail: {
                        errorMessage: e.responseJSON.description,
                      },
                    })
                  ),
                  this.$form.prepend(
                    '<div class="errors text-center">' +
                      e.responseJSON.description +
                      "</div>"
                  ));
            },
          })),
          i
        );
      })()),
      (theme.collapsibles = (function () {
        var e = {
          trigger: ".collapsible-trigger",
          module: ".collapsible-content",
          moduleInner: ".collapsible-content__inner",
          tabs: ".collapsible-trigger--tab",
        };
        var i = {
          hide: "hide",
          open: "is-open",
          autoHeight: "collapsible--auto-height",
          tabs: "collapsible-trigger--tab",
        };
        var n = ".collapsible";
        var a = !1;

        function o() {
          t(e.trigger).each(function () {
            var e = t(this);
            var n = e.hasClass(i.open);
            e.attr("aria-expanded", n);
          }),
            t("body")
              .off(n)
              .on("click" + n, e.trigger, function () {
                if (!a) {
                  a = !0;
                  var n = t(this);
                  var o = n.hasClass(i.open);
                  var r = n.hasClass(i.tabs);
                  var c = n.attr("aria-controls");
                  var d = t("#" + c);
                  var l = d.find(e.moduleInner).outerHeight();
                  var h = n.hasClass(i.autoHeight);
                  if (r) {
                    if (o) return (a = !1), void 0;
                    var u;
                    t(e.tabs + "[data-id=" + n.data("id") + "]").each(
                      function () {
                        t(this).removeClass(i.open),
                          s(
                            (u = t("#" + t(this).attr("aria-controls"))),
                            0,
                            !0
                          );
                      }
                    );
                  }
                  o &&
                    h &&
                    setTimeout(function () {
                      s(d, (l = 0), o, h);
                    }, 0),
                    o && !h && (l = 0),
                    n.attr("aria-expanded", !o).toggleClass(i.open, !o),
                    s(d, l, o, h);
                }
              });
        }

        function s(t, e, n, o) {
          if (
            (t
              .removeClass(i.hide)
              .prepareTransition()
              .css("height", e)
              .toggleClass(i.open, !n),
            !n && o)
          ) {
            var s = t;
            window.setTimeout(function () {
              s.css("height", "auto"), (a = !1);
            }, 0);
          } else a = !1;
        }
        return {
          init: o,
        };
      })()),
      (theme.headerNav = (function () {
        var e = {
          wrapper: ".header-wrapper",
          siteHeader: ".site-header",
          logoContainer: ".site-header__logo",
          logo: ".site-header__logo img",
          navigation: ".site-navigation",
          navContainerWithLogo: ".header-item--logo",
          navItems: ".site-nav__item",
          navLinks: ".site-nav__link",
          navLinksWithDropdown: ".site-nav__link--has-dropdown",
          navDropdownLinks: ".site-nav__dropdown-link--second-level",
          thumbMenu: ".site-nav__thumb-menu",
        };
        var i = {
          hasDropdownClass: "site-nav--has-dropdown",
          hasSubDropdownClass: "site-nav__deep-dropdown-trigger",
          dropdownActive: "is-focused",
          stickyCartActive: "body--sticky-cart-open",
          overlayEnabledClass: "header-wrapper--overlay",
          overlayedClass: "is-light",
          thumbMenuInactive: "site-nav__thumb-menu--inactive",
          stickyClass: "site-header--sticky",
          overlayStickyClass: "header-wrapper--sticky",
          openTransitionClass: "site-header--opening",
        };
        var n = {
          namespace: ".siteNav",
          overlayHeader: !1,
          stickyActive: !1,
          forceStickyOnMobile: !1,
          forceCloseThumbNav: !1,
        };
        var a;
        var o;
        var s;
        var r;
        var c;
        var d;

        function l() {
          (a = t(window)),
            (o = t(e.navContainerWithLogo)),
            (s = t(e.logoContainer)),
            (r = t(e.navigation)),
            (c = t(e.wrapper)),
            (d = t(e.siteHeader)),
            (n.overlayHeader = theme.settings.overlayHeader =
              d.data("overlay")),
            (n.stickyActive = !1),
            v();
          var i = new theme.Modals("SearchModal", "search-modal", {
            closeOffContentClick: !1,
            focusOnOpen: "#SearchModalInput",
          });
          a
            .on("resize" + n.namespace, t.debounce(150, u))
            .on("load" + n.namespace, h),
            m(),
            a.on("scroll" + n.namespace, t.throttle(150, w)),
            Shopify.designMode && a.trigger("resize");
        }

        function h() {
          f(), b(), "bar" === n.headerStyle && g();
        }

        function u() {
          f(), m(), "bar" === n.headerStyle && y();
        }

        function m() {
          theme.config.bpSmall
            ? (n.headerStyle = "button")
            : (n.headerStyle = c.data("header-style")),
            (n.stickyThreshold = "button" === n.headerStyle ? 100 : 250),
            "button" !== n.headerStyle && S(!1);
        }

        function p() {
          t(window).off(n.namespace),
            t(e.navLinks).off(n.namespace),
            t(e.navDropdownLinks).off(n.namespace);
        }

        function f() {
          t(e.logo).each(function () {
            var e = t(this),
              i = e.width(),
              n = e.closest(".grid__item").width();
            i > n ? e.css("maxWidth", n) : e.removeAttr("style");
          });
        }

        function v() {
          var a = !1;
          var o = !1;
          var s = !1;

          function r(e) {
            var o = e.parent();
            if (
              (o.hasClass(i.hasDropdownClass) &&
                (o.addClass(i.dropdownActive), (a = !0)),
              !theme.config.isTouch && !s)
            ) {
              var r = theme.config.isTouch ? "touchend" : "click";
              (s = !0),
                t("body").on(r + n.namespace, function () {
                  d(), t("body").off(n.namespace), (s = !1);
                });
            }
          }

          function c(t, e) {
            var n = t.parent();
            (n.hasClass(i.hasSubDropdownClass) || e) &&
              (n.addClass(i.dropdownActive), (o = !0));
          }

          function d() {
            l(), h();
          }

          function l() {
            t(e.navItems).removeClass(i.dropdownActive);
          }

          function h() {
            t(e.navDropdownLinks).parent().removeClass(i.dropdownActive);
          }
          theme.config.isTouch &&
            (t(e.navLinksWithDropdown).on(
              "touchend" + n.namespace,
              function (e) {
                var n = t(this);
                var a;
                n.parent().hasClass(i.dropdownActive)
                  ? window.location.replace(n.attr("href"))
                  : (e.preventDefault(), d(), r(n));
              }
            ),
            t(e.navDropdownLinks).on("touchend" + n.namespace, function (e) {
              var n = t(this);
              var a = n.parent();
              a.hasClass(i.hasSubDropdownClass)
                ? a.hasClass(i.dropdownActive)
                  ? window.location.replace(n.attr("href"))
                  : (e.preventDefault(), h(), c(n))
                : window.location.replace(n.attr("href"));
            })),
            t(e.navLinks).on("focusin mouseover" + n.namespace, function () {
              a && l(), o && h(), r(t(this));
            }),
            t(e.navLinks).on("mouseleave" + n.namespace, function () {
              d();
            }),
            t(e.navDropdownLinks).on("focusin" + n.namespace, function () {
              h(), c(t(this), !0);
            });
        }

        function g() {
          d.wrap('<div class="site-header-sticky"></div>'),
            n.overlayHeader ||
              (y(),
              setTimeout(function () {
                y(),
                  0 === t(".site-header-sticky").outerHeight() &&
                    setTimeout(function () {
                      a.trigger("resize");
                    }, 500);
              }, 200));
        }

        function y() {
          t(".site-header-sticky").css("height", d.outerHeight(!0));
        }

        function b() {
          t("body").hasClass(i.stickyCartActive) ||
            (theme.config.bpSmall &&
              "product" !== theme.template &&
              setTimeout(function () {
                (n.forceStickyOnMobile = !0), S(!0);
              }, 25));
        }

        function w(t) {
          var e;
          if (a.scrollTop() > n.stickyThreshold) {
            if (
              (n.forceStickyOnMobile && (n.forceStickyOnMobile = !1),
              n.stickyActive)
            )
              return;
            "button" === n.headerStyle
              ? S(!0)
              : "bar" === n.headerStyle && C(!0);
          } else {
            if (n.forceStickyOnMobile) return;
            if (!n.stickyActive) return;
            "button" === n.headerStyle
              ? theme.config.bpSmall || S(!1)
              : "bar" === n.headerStyle && C(!1),
              n.overlayHeader || y();
          }
        }

        function S(a, o) {
          n.forceCloseThumbNav ||
            t(".slide-nav__overflow--thumb").hasClass("js-menu--is-open") ||
            (t(e.thumbMenu).toggleClass(i.thumbMenuInactive, !a),
            (n.stickyActive = a),
            (n.forceCloseThumbNav = o));
        }

        function C(t) {
          "bar" === n.headerStyle &&
            (t
              ? (d.addClass(i.stickyClass),
                n.overlayHeader &&
                  c
                    .removeClass(i.overlayedClass)
                    .addClass(i.overlayStickyClass),
                setTimeout(function () {
                  d.addClass(i.openTransitionClass);
                }, 100))
              : (d
                  .removeClass(i.openTransitionClass)
                  .removeClass(i.stickyClass),
                n.overlayHeader &&
                  c
                    .addClass(i.overlayedClass)
                    .removeClass(i.overlayStickyClass)),
            (n.stickyActive = t));
        }

        function $() {
          t(e.wrapper)
            .removeClass(i.overlayEnabledClass)
            .removeClass(i.overlayedClass),
            (n.overlayHeader = theme.settings.overlayHeader = !1);
        }
        return {
          init: l,
          disableOverlayHeader: $,
          toggleThumbMenu: S,
          unload: p,
        };
      })()),
      (theme.slideNav = (function () {
        var e = {
          container: "#PageContainer",
          navWrapper: ".slide-nav__overflow",
          nav: "#SlideNav",
          toggleBtn: ".js-toggle-slide-nav",
          subNavToggleBtn: ".js-toggle-submenu",
          thumbNavToggle: ".site-nav__thumb-button",
        };
        var i = {
          subNavLink: "slide-nav__sublist-link",
          return: "slide-nav__return-btn",
          isActive: "is-active",
          isOpen: "js-menu--is-open",
          subNavShowing: "sub-nav--is-open",
          thirdNavShowing: "third-nav--is-open",
        };
        var n = ".slideNav";
        var a;
        var o;
        var s;
        var r = !0;
        var c = 1;

        function d() {
          t(e.thumbNavToggle).length && (r = !1),
            t(e.toggleBtn).on("click" + n, l),
            t(e.subNavToggleBtn).on("click" + n, m);
        }

        function l() {
          t(e.toggleBtn).hasClass(i.isActive) ? u() : h();
        }

        function h() {
          t(e.toggleBtn).addClass(i.isActive),
            t(e.navWrapper).prepareTransition().addClass(i.isOpen),
            $("body").addClass('menu-opening'),
            r &&
              t(e.container).css({
                transform:
                  "translate3d(0, " + t(e.navWrapper).height() + "px, 0)",
              }),
            t(e.navWrapper).attr("tabindex", "-1").focus(),
            t(window).on("keyup" + n, function (t) {
              27 === t.which && u();
            });
        }

        function u() {
          t(e.toggleBtn).removeClass(i.isActive),
            t(e.navWrapper).prepareTransition().removeClass(i.isOpen),
            $("body").removeClass('menu-opening'),
            r && t(e.container).removeAttr("style"),
            t(e.toggleBtn).focus(),
            t(window).off("keyup" + n);
        }

        function m(e) {
          if (!a) {
            var n = t(e.currentTarget);
            var o = n.hasClass(i.return);
            (a = !0),
              o
                ? (t(
                    i.toggleBtn + '[data-level="' + (c - 1) + '"]'
                  ).removeClass(i.isActive),
                  t('.slide-nav__dropdown[data-level="' + c + '"]')
                    .prepareTransition()
                    .removeClass(i.isActive),
                  s && s.length && s.removeClass(i.isActive))
                : (n.addClass(i.isActive),
                  n
                    .next(".slide-nav__dropdown")
                    .prepareTransition()
                    .addClass(i.isActive)),
              (s = n),
              p(n.data("target"));
          }
        }

        function p(n) {
          var d = t(
            n ? '.slide-nav__dropdown[data-parent="' + n + '"]' : e.nav
          );
          (c = d.data("level") ? d.data("level") : 1), (o = d);
          var l = n ? d.find("." + i.subNavLink + ":first") : s;
          var h = d.outerHeight();
          var u = c > 2 ? i.thirdNavShowing : i.subNavShowing;
          t(e.navWrapper)
            .css("height", h)
            .removeClass(i.thirdNavShowing)
            .addClass(u),
            n ||
              t(e.navWrapper)
                .removeClass(i.thirdNavShowing)
                .removeClass(i.subNavShowing),
            (a = !1),
            r &&
              t(e.container).css({
                transform: "translate3d(0, " + h + "px, 0)",
              });
        }

        function f() {
          t(window).off(n), t(e.toggleBtn).off(n), t(e.subNavToggleBtn).off(n);
        }
        return {
          init: d,
          unload: f,
        };
      })());

    function e() {
      var e = t.Deferred();
      var i;
      var n;
      return (
        (i = setInterval(function () {
          Vimeo && (clearInterval(i), clearTimeout(n), e.resolve());
        }, 500)),
        (n = setTimeout(function () {
          clearInterval(i), e.reject();
        }, 4e3)),
        e
      );
    }
    (theme.articleImages = (function () {
      var e = {};

      function i() {
        (e.$rteImages = t(".rte--indented-images")),
          e.$rteImages.length && t(window).on("load", n);
      }

      function n() {
        e.$rteImages.find("img").each(function () {
          var i = t(this);
          var n = i.attr("style");
          (n && "float: none;" != n) ||
            (i.width() < e.$rteImages.width() && i.addClass("rte__no-indent"));
        });
      }
      return {
        init: i,
      };
    })()),
      (theme.Slideshow = (function () {
        this.$slideshow = null;
        var e = {
          next: "is-next",
          init: "is-init",
          wrapper: "slideshow-wrapper",
          slideshow: "slideshow",
          currentSlide: "slick-current",
          pauseButton: "slideshow__pause",
          isPaused: "is-paused",
        };

        function i(i, n) {
          (this.$slideshow = t(i)),
            (this.$wrapper = this.$slideshow.closest("." + e.wrapper)),
            (this.$pause = this.$wrapper.find("." + e.pauseButton)),
            (this.settings = {
              accessibility: !0,
              arrows: !!n.arrows,
              dots: !!n.dots,
              draggable: !0,
              touchThreshold: 8,
              speed: 300,
              pauseOnHover: !!n.pauseOnHover,
              rtl: theme.config.rtl,
              autoplay: this.$slideshow.data("autoplay"),
              autoplaySpeed: this.$slideshow.data("speed"),
            }),
            this.$slideshow.on("init", this.init.bind(this)),
            t(".root").find(this.$slideshow).length &&
              t("body").on(
                "productModalClose",
                function () {
                  this.$slideshow.addClass("slideshow-refresh"),
                    this.$slideshow.slick("refresh");
                }.bind(this)
              ),
            this.$slideshow.slick(this.settings),
            this.$pause.on("click", this._togglePause.bind(this));
        }
        return (
          (i.prototype = t.extend({}, i.prototype, {
            init: function (t, i) {
              (this.$slideshowList = i.$list),
                (this.$slickDots = i.$dots),
                (this.$allSlides = i.$slides),
                (this.slideCount = i.slideCount),
                this.$slideshow.addClass(e.init),
                this._a11y(),
                this._clonedLazyloading(),
                setTimeout(
                  function () {
                    this.$slideshow.slick("setPosition");
                  }.bind(this),
                  50
                );
            },
            destroy: function () {
              this.$slideshow.slick("unslick");
            },
            _play: function () {
              this.$slideshow.slick("slickPause"),
                t(e.pauseButton).addClass("is-paused");
            },
            _pause: function () {
              this.$slideshow.slick("slickPlay"),
                t(e.pauseButton).removeClass("is-paused");
            },
            _togglePause: function () {
              var i = this._getSlideshowId(this.$pause);
              this.$pause.hasClass(e.isPaused)
                ? (this.$pause.removeClass(e.isPaused), t(i).slick("slickPlay"))
                : (this.$pause.addClass(e.isPaused), t(i).slick("slickPause"));
            },
            _getSlideshowId: function (t) {
              return "#Slideshow-" + t.data("id");
            },
            _activeSlide: function () {
              return this.$slideshow.find(".slick-active");
            },
            _currentSlide: function () {
              return this.$slideshow.find(".slick-current");
            },
            _nextSlide: function (t) {
              return this.$slideshow.find(
                '.slideshow__slide[data-slick-index="' + t + '"]'
              );
            },
            _a11y: function () {
              var i = this.$slideshowList;
              var n = this.settings.autoplay;
              i &&
                (i.removeAttr("aria-live"),
                t(e.wrapper).on(
                  "focusin",
                  function (a) {
                    t(e.wrapper).has(a.target).length &&
                      (i.attr("aria-live", "polite"), n && this._pause());
                  }.bind(this)
                ),
                t(e.wrapper).on(
                  "focusout",
                  function (a) {
                    t(e.wrapper).has(a.target).length &&
                      (i.removeAttr("aria-live"), n && this._play());
                  }.bind(this)
                ));
            },
            _clonedLazyloading: function () {
              var e = this.$slideshow;
              e.find(".slick-slide").each(
                function (i, n) {
                  var a = t(n);
                  if (a.hasClass("slick-cloned")) {
                    var o = a.data("id");
                    var s = a
                      .find(".hero__image")
                      .removeClass("lazyloading")
                      .addClass("lazyloaded");
                    setTimeout(function () {
                      var t = e
                        .find(
                          ".slideshow__slide--" +
                            o +
                            ":not(.slick-cloned) .hero__image"
                        )
                        .attr("style");
                      t && s.attr("style", t);
                    }, this.settings.autoplaySpeed / 1.5);
                  }
                }.bind(this)
              );
            },
          })),
          i
        );
      })()),
      (theme.QuickShopScreens = (function () {
        var e = window.location.pathname;
        var i = e;
        var n = null;
        var a = null;
        "scrollRestoration" in history &&
          (history.scrollRestoration = "manual");
        var o = {
          screensWrap: "#ProductScreens",
          screens: "[data-product-id]",
          trigger: ".quick-product__btn",
        };
        var s = [];

        function r(t) {
          var e;
          theme.settings.quickView && (u(l()), c());
        }

        function c() {
          Shopify.designMode ||
            (t(window).on("newPopstate", function (t, o) {
              (a = o.screen),
                o.back &&
                  ((n = location.pathname),
                  (i = e),
                  history.pushState({}, "", e)),
                o.url &&
                  o.updateCurrentPath &&
                  ((n = location.pathname),
                  (i = o.url),
                  history.pushState({}, "", o.url));
            }),
            t(window).on(
              "popstate",
              function (o) {
                var s = !1;
                if (((n = i), location.pathname !== i)) {
                  if (
                    ((n = i), (i = location.pathname), location.pathname === e)
                  )
                    return a && a.isOpen && d(a), void 0;
                  if (-1 !== location.pathname.indexOf("/products/"))
                    return (
                      a
                        ? a.open()
                        : t(
                            '.quick-product__btn[href="' +
                              location.pathname +
                              '"]'
                          )
                            .first()
                            .trigger("click", {
                              updateCurrentPath: !1,
                            }),
                      void 0
                    );
                  if (o.originalEvent.state) {
                    if (a && a.isOpen)
                      return d(a), history.replaceState({}, "", e), void 0;
                    s = !0;
                  } else if (a) {
                    if (a.isOpen) return d(a), void 0;
                  } else s = !0;
                  s && (window.location.href = location.href);
                }
              }.bind(this)
            ));
        }

        function d(e) {
          e.close(), (a = null), t(window).trigger("resize");
        }

        function l(e) {
          var i = [];
          var n;
          return (
            (e ? t(o.trigger, e) : t(o.trigger)).each(function () {
              var e = t(this).data("product-id");
              if (i.indexOf(e) > -1)
                return (
                  t('.screen-layer--product[data-product-id="' + e + '"]')
                    .slice(1)
                    .remove(),
                  void 0
                );
              i.push(e);
            }),
            i
          );
        }

        function h(e) {
          var i = [];
          return (
            e.each(function () {
              var e = t(this).data("product-id");
              i.push(e);
            }),
            i
          );
        }

        function u(e) {
          var i;
          var n;
          var a = [];
          for (var r = 0; r < e.length; r++)
            -1 === s.indexOf(e[r]) &&
              ((i = "ProductScreen-" + e[r]),
              (n = t("#" + i)),
              a.push(n),
              s.push(e[r]),
              new theme.ProductScreen(i, "product-" + e[r]));
          t(o.screensWrap).append(a);
        }

        function m(e) {
          if (theme.settings.quickView) {
            var i = [];
            var n = l(e);
            var a;
            var s = h(t(o.trigger).not(t(o.trigger, e)));
            for (var r = 0; r < n.length; r++) {
              var c = n[r];
              -1 === s.indexOf(c) && i.push(c);
            }
            for (var r = 0; r < i.length; r++) sections._removeInstance(i[r]);
          }
        }

        function p(e) {
          if (theme.settings.quickView) {
            var i = l(e);
            u(i),
              f(i, e),
              sections.register(
                "product-template",
                theme.Product,
                t("#ProductScreens")
              );
          }
        }

        function f(e, i) {
          for (var n = 0; n < e.length; n++)
            t(
              '.screen-layer--product[data-product-id="' + e[n] + '"]',
              i
            ).remove();
        }
        return {
          init: r,
          unload: m,
          reInit: p,
        };
      })()),
      (theme.HoverProductGrid = (function () {
        var e = {
          product: ".grid-product",
          slider: ".product-slider",
        };

        function i(t) {
          (this.$container = t),
            (this.sectionId = this.$container.attr("data-section-id")),
            (this.namespace = ".product-image-slider-" + this.sectionId),
            (this.activeIds = []),
            theme.settings.hoverProductGrid &&
              ((this.$products = t.find(e.product)),
              (this.slidersMobile = t.data("product-sliders-mobile")),
              0 !== this.$products.length &&
                theme.utils.promiseStylesheet().then(
                  function () {
                    this.init();
                  }.bind(this)
                ));
        }
        return (
          (i.prototype = t.extend({}, i.prototype, {
            init: function () {
              this.destroyAllSliders(),
                this.setupEventType(),
                this.listnerSetup();
            },
            setupEventType: function () {
              this.$products.off("mouseenter mouseout tap"),
                t(window).off("scroll" + this.namespace),
                theme.config.bpSmall
                  ? this.slidersMobile &&
                    (t(window).on(
                      "scroll" + this.namespace,
                      t.throttle(120, this.inViewSliderInit.bind(this))
                    ),
                    t(window).trigger("scroll" + this.namespace))
                  : this.mouseSliderInit();
            },
            listnerSetup: function () {
              t("body").on(
                "matchSmall matchLarge",
                function () {
                  this.destroyAllSliders(), this.setupEventType();
                }.bind(this)
              );
            },
            inViewSliderInit: function () {
              this.$products.find(e.slider).each(
                function (e, i) {
                  theme.isElementVisible(t(i), -400)
                    ? this.initSlider(t(i))
                    : this.destroySlider(t(i));
                }.bind(this)
              );
            },
            mouseSliderInit: function () {
              this.$products.on(
                "mouseenter taphold",
                function (i) {
                  // alert('test');
                  var n = t(i.currentTarget).find(e.slider);
                  this.initSlider(n);
                }.bind(this)
              ),
                this.$products.on(
                  "mouseleave",
                  function (i) {
                    var n = t(i.currentTarget).find(e.slider);
                    this.destroySlider(n);
                  }.bind(this)
                );
            },
            initSlider: function (t) {
              t.data("image-count") < 2 ||
                (-1 === this.activeIds.indexOf(t.data("id")) &&
                  (this.activeIds.push(t.data("id")),
                  t.addClass("product-slider--init").slick({
                    autoplay: !0,
                    infinite: !0,
                    arrows: !1,
                    speed: 300,
                    fade: !0,
                    pauseOnHover: !1,
                    autoplaySpeed: 1050,
                  })));
            },
            destroySlider: function (t) {
              if (!(t.data("image-count") < 2)) {
                var e = this.activeIds.indexOf(t.data("id"));
                -1 !== e && (this.activeIds.splice(e, 1), t.slick("unslick"));
              }
            },
            destroyAllSliders: function () {
              this.$products.find(e.slider).each(
                function (e, i) {
                  this.destroySlider(t(i));
                }.bind(this)
              );
            },
          })),
          i
        );
      })()),
      (theme.videoModal = function (e) {
        var i = null;
        var n = {
          width: 1280,
          height: 720,
          playerVars: {
            autohide: 0,
            autoplay: 1,
            branding: 0,
            cc_load_policy: 0,
            fs: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            playsinline: 1,
            quality: "hd720",
            rel: 0,
            showinfo: 0,
            wmode: "opaque",
          },
          events: {
            onReady: h,
          },
        };
        var a = "VideoHolder";
        var o = !1;
        var s = {
          videoHolder: "#" + a,
          youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
          mp4Trigger: ".product-video-trigger--mp4",
          mp4Player: ".product-video-mp4-sound",
        };
        if (t(s.youtube).length || t(s.mp4Trigger).length) {
          var r = new theme.Modals("VideoModal", "video-modal", {
            closeOffContentClick: !0,
            solid: !0,
          });
          e && (t(s.youtube).off("click"), t(s.mp4Trigger).off("click")),
            t(s.youtube).on("click", c),
            t(s.mp4Trigger).on("click", d),
            e && t("body").off("modalClose.VideoModal"),
            t("body").on("modalClose.VideoModal", function () {
              i && "youtube" === o
                ? setTimeout(function () {
                    i.destroy();
                  }, 500)
                : m();
            });
        }

        function c(e) {
          m(),
            e.preventDefault(),
            theme.LibraryLoader.load("youtubeSdk"),
            theme.config.youTubeReady
              ? l(e)
              : t("body").on("youTubeReady", function () {
                  l(e);
                });
        }

        function d(e) {
          var i;
          var n;
          m(),
            t(e.currentTarget)
              .next(s.mp4Player)
              .clone()
              .removeClass("hide")
              .appendTo(s.videoHolder),
            r.open(e),
            t(s.videoHolder).find("video")[0].play(),
            (o = "mp4");
        }

        function l(e) {
          var s;
          var c = u(t(e.currentTarget).attr("href"));
          var d = t.extend({}, n, {
            videoId: c,
          });
          (d.playerVars.playsinline = theme.config.bpSmall ? 0 : 1),
            (i = new YT.Player(a, d)),
            r.open(e),
            (o = "youtube");
        }

        function h(t) {
          t.target.playVideo();
        }

        function u(t) {
          var e =
            /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
          var i = t.match(e);
          return !(!i || 11 != i[7].length) && i[7];
        }

        function m() {
          t(s.videoHolder).empty();
        }
      }),
      (theme.Disclosure = (function () {
        var e = {
          disclosureList: "[data-disclosure-list]",
          disclosureToggle: "[data-disclosure-toggle]",
          disclosureInput: "[data-disclosure-input]",
          disclosureOptions: "[data-disclosure-option]",
        };
        var i = {
          listVisible: "disclosure-list--visible",
        };

        function n(t) {
          (this.$container = t),
            (this.cache = {}),
            this._cacheSelectors(),
            this._connectOptions(),
            this._connectToggle(),
            this._onFocusOut();
        }
        return (
          (n.prototype = t.extend({}, n.prototype, {
            _cacheSelectors: function () {
              this.cache = {
                $disclosureList: this.$container.find(e.disclosureList),
                $disclosureToggle: this.$container.find(e.disclosureToggle),
                $disclosureInput: this.$container.find(e.disclosureInput),
                $disclosureOptions: this.$container.find(e.disclosureOptions),
              };
            },
            _connectToggle: function () {
              this.cache.$disclosureToggle.on(
                "click",
                function (e) {
                  var n = "true" === t(e.currentTarget).attr("aria-expanded");
                  t(e.currentTarget).attr("aria-expanded", !n),
                    this.cache.$disclosureList.toggleClass(i.listVisible);
                }.bind(this)
              );
            },
            _connectOptions: function () {
              this.cache.$disclosureOptions.on(
                "click",
                function (e) {
                  e.preventDefault(),
                    this._submitForm(t(e.currentTarget).data("value"));
                }.bind(this)
              );
            },
            _onFocusOut: function () {
              this.cache.$disclosureToggle.on(
                "focusout",
                function (t) {
                  var e;
                  0 === this.$container.has(t.relatedTarget).length &&
                    this._hideList();
                }.bind(this)
              ),
                this.cache.$disclosureList.on(
                  "focusout",
                  function (e) {
                    var n = t(e.currentTarget).has(e.relatedTarget).length > 0;
                    var a;
                    this.cache.$disclosureList.hasClass(i.listVisible) &&
                      !n &&
                      this._hideList();
                  }.bind(this)
                ),
                this.$container.on(
                  "keyup",
                  function (t) {
                    27 === t.which &&
                      (this._hideList(), this.cache.$disclosureToggle.focus());
                  }.bind(this)
                ),
                t("body").on(
                  "click",
                  function (t) {
                    var e = this.$container.has(t.target).length > 0;
                    var n;
                    this.cache.$disclosureList.hasClass(i.listVisible) &&
                      !e &&
                      this._hideList();
                  }.bind(this)
                );
            },
            _submitForm: function (e) {
              t("body").addClass("unloading"),
                this.cache.$disclosureInput.val(e),
                this.$container.parents("form").submit();
            },
            _hideList: function () {
              this.cache.$disclosureList.removeClass(i.listVisible),
                this.cache.$disclosureToggle.attr("aria-expanded", !1);
            },
            unload: function () {
              this.cache.$disclosureOptions.off(),
                this.cache.$disclosureToggle.off(),
                this.cache.$disclosureList.off(),
                this.$container.off();
            },
          })),
          n
        );
      })()),
      (theme.ProductMedia = (function () {
        var e = {};
        var i = {};
        var n = {};
        var a = {
          mediaGroup: "[data-product-single-media-group]",
          xrButton: "[data-shopify-xr]",
        };

        function o(o, c) {
          (e[c] = {
            loaded: !1,
          }),
            o.each(function (e) {
              var o = t(this);
              var s = o.data("media-id");
              var r = t(o.find("model-viewer")[0]);
              var d = r.data("model-id");
              if (0 === e) {
                var l = o.closest(a.mediaGroup).find(a.xrButton);
                n[c] = {
                  $element: l,
                  defaultId: d,
                };
              }
              i[s] = {
                modelId: d,
                sectionId: c,
                $container: o,
                $element: r,
              };
            }),
            window.Shopify.loadFeatures([
              {
                name: "shopify-xr",
                version: "1.0",
                onLoad: s,
              },
              {
                name: "model-viewer-ui",
                version: "1.0",
                onLoad: r,
              },
            ]),
            theme.LibraryLoader.load("modelViewerUiStyles");
        }

        function s(i) {
          if (!i) {
            if (!window.ShopifyXR)
              return (
                document.addEventListener(
                  "shopify_xr_initialized",
                  function () {
                    s();
                  }
                ),
                void 0
              );
            for (var n in e)
              if (e.hasOwnProperty(n)) {
                var a = e[n];
                if (a.loaded) continue;
                var o = t("#ModelJson-" + n);
                window.ShopifyXR.addModels(JSON.parse(o.html())),
                  (a.loaded = !0);
              }
            window.ShopifyXR.setupXRElements();
          }
        }

        function r(t) {
          if (!t)
            for (var e in i)
              if (i.hasOwnProperty(e)) {
                var n = i[e];
                !n.modelViewerUi &&
                  Shopify &&
                  (n.modelViewerUi = new Shopify.ModelViewerUI(n.$element)),
                  c(n);
              }
        }

        function c(t) {
          var e = n[t.sectionId];
          t.$container.on("mediaVisible", function () {
            e.$element.attr("data-shopify-model3d-id", t.modelId),
              theme.config.isTouch || t.modelViewerUi.play();
          }),
            t.$container
              .on("mediaHidden", function () {
                e.$element.attr("data-shopify-model3d-id", e.defaultId),
                  t.modelViewerUi.pause();
              })
              .on("xrLaunch", function () {
                t.modelViewerUi.pause();
              });
        }

        function d(t) {
          for (var n in i) {
            var a;
            if (i.hasOwnProperty(n)) i[n].sectionId === t && delete i[n];
          }
          delete e[t];
        }
        return {
          init: o,
          removeSectionModels: d,
        };
      })()),
      (theme.customerTemplates = (function () {
        function e() {
          t("#RecoverPassword").on("click", function (t) {
            t.preventDefault(), i();
          }),
            t("#HideRecoverPasswordLink").on("click", function (t) {
              t.preventDefault(), i();
            });
        }

        function i() {
          t("#RecoverPasswordForm").toggleClass("hide"),
            t("#CustomerLoginForm").toggleClass("hide");
        }

        function n() {
          var e;
          t(".reset-password-success").length &&
            t("#ResetSuccess").removeClass("hide");
        }

        function a() {
          var e = t("#AddressNewForm");
          var i = t(".js-address-form");
          e.length &&
            i.length &&
            (Shopify &&
              t(".js-address-country").each(function () {
                var e = t(this);
                var i = e.data("country-id");
                var n = e.data("province-id");
                var a = e.data("province-container-id");
                Shopify &&
                  new Shopify.CountryProvinceSelector(i, n, {
                    hideElement: a,
                  });
              }),
            t(".address-new-toggle").on("click", function () {
              e.toggleClass("hide");
            }),
            t(".address-edit-toggle").on("click", function () {
              var e = t(this).data("form-id");
              t("#EditAddress_" + e).toggleClass("hide");
            }),
            t(".address-delete").on("click", function () {
              var e = t(this);
              var i = e.data("form-id");
              var n = e.data("confirm-message");
              confirm(n || "Are you sure you wish to delete this address?") &&
                Shopify &&
                Shopify.postLink("/account/addresses/" + i, {
                  parameters: {
                    _method: "delete",
                  },
                });
            }));
        }

        function o() {
          var t;
          "#recover" === window.location.hash && i();
        }
        return {
          init: function () {
            o(), e(), n(), a();
          },
        };
      })()),
      (theme.Product = (function () {
        var e = {
          onSale: "sale-price",
          disabled: "disabled",
          isModal: "is-modal",
          loading: "loading",
          loaded: "loaded",
          hidden: "hide",
          interactable: "video-interactable",
          visuallyHide: "visually-invisible",
          thumbActive: "thumb--current",
        };
        var i = {
          variantsJson: "[data-variant-json]",
          currentVariantJson: "[data-current-variant-json]",
          imageContainer: "[data-product-images]",
          mainSlider: "[data-product-photos]",
          thumbSlider: "[data-product-thumbs]",
          photo: "[data-product-photo]",
          photoThumbs: "[data-product-thumb]",
          photoThumbItem: "[data-product-thumb-item]",
          zoomButton: ".product__photo-zoom",
          priceWrapper: "[data-price-wrapper]",
          price: "[data-product-price]",
          comparePrice: "[data-product-price-compare]",
          priceA11y: "[data-price-a11y]",
          comparePriceA11y: "[data-compare-a11y]",
          sku: "[data-sku]",
          inventory: "[data-product-inventory]",
          incomingInventory: "[data-product-incoming-inventory]",
          unitWrapper: "[data-product-unit-wrapper]",
          addToCart: "[data-add-to-cart]",
          addToCartText: "[data-add-to-cart-text]",
          originalSelectorId: "[data-product-select]",
          singleOptionSelector: "[data-variant-input]",
          variantColorSwatch: "[data-color-swatch]",
          productImageMain: ".product-image-main",
          dotsContainer: ".product__photo-dots",
          productVideo: "[data-product-video]",
          videoParent: ".product__video-wrapper",
          currentSlide: ".slick-current",
          startingSlide: ".starting-slide",
          media: "[data-product-media-type-model]",
          closeMedia: ".product-single__close-media",
          modalFormHolder: "#ProductFormPlaceholder-",
          formContainer: ".product-single__form",
          availabilityContainer: "[data-store-availability]",
        };
        var n;
        var a = {};
        var o = [];
        var s = {
          height: "480",
          width: "850",
          playerVars: {
            autohide: 0,
            autoplay: 0,
            branding: 0,
            cc_load_policy: 0,
            controls: 0,
            fs: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            playsinline: 1,
            quality: "hd720",
            rel: 0,
            showinfo: 0,
            wmode: "opaque",
          },
        };

        function r(e, n) {
          var s = t("#" + n);
          var r = s.attr("id");
          o[r] = e.target;
          var d = o[r];
          m(s),
            "muted" === a[r].style && o[r].mute(),
            p(s),
            (s.closest(i.startingSlide).length ||
              1 === s.data("image-count")) &&
              "muted" === a[r].style &&
              (o[r].playVideo(), c(r));
        }

        function c(e) {
          e &&
            (d(e),
            t(window).on(
              "scroll." + e,
              {
                id: e,
              },
              t.throttle(150, d)
            ));
        }

        function d(e) {
          var i;
          if (e) {
            if ("string" == typeof e) i = e;
            else {
              if (!e.data) return;
              i = e.data.id;
            }
            if (theme.isElementVisible(t("#" + i))) {
              if (a[i] && "unmuted" === a[i].style) return;
              l(i);
            } else h(i);
          }
        }

        function l(t) {
          o[t] && "function" == typeof o[t].playVideo && o[t].playVideo();
        }

        function h(t) {
          o[t] && "function" == typeof o[t].pauseVideo && o[t].pauseVideo();
        }

        function u(e, i) {
          var n = t("#" + i);
          var s = n.attr("id");
          var r = o[s];
          switch (e.data) {
            case -1:
              a[s].attemptedToPlay && (p(n), f(n));
              break;
            case 0:
              a[s] && a[s].loop && r.playVideo();
              break;
            case 1:
              p(n);
              break;
            case 3:
              a[s].attemptedToPlay = !0;
              break;
          }
        }

        function m(t) {
          t.closest(i.videoParent).addClass(e.loading);
        }

        function p(t) {
          t.closest(i.videoParent).removeClass(e.loading).addClass(e.loaded);
        }

        function f(t) {
          t.closest(i.videoParent).addClass(e.interactable);
        }

        function v(e) {
          var n = (this.$container = t(e));
          var a = (this.sectionId = n.attr("data-section-id"));
          (this.inModal = n.closest(".screen-layer").length),
            this.$modal,
            (this.namespace = ".product-" + a),
            (this.namespaceImages = ".product-image-" + a),
            (this.settings = {
              enableHistoryState: n.data("enable-history-state") || !1,
              namespace: ".product-" + a,
              variantType: n.data("variant-type"),
              inventory: n.data("inventory") || !1,
              inventoryThreshold: n.data("inventory-threshold") || !1,
              incomingInventory: n.data("incoming-inventory") || !1,
              modalInit: !1,
              slickMainInitialized: !1,
              slickThumbInitialized: !1,
              hasImages: !0,
              hasVideos: n.find(i.productVideo).length || !1,
              videoStyle: n.data("video-style"),
              has3d: !1,
              hasMultipleImages: !1,
              imageSetName: null,
              imageSetIndex: null,
              currentImageSet: null,
              stackedImages: n.data("images-stacked") || !1,
              stackedCurrent: 0,
              stackedImagePositions: [],
              imageSize: "620x",
              videoLooping: n.data("video-looping"),
            }),
            (this.videos = {}),
            this.inModal &&
              ((this.settings.enableHistoryState = !1),
              (this.namespace = ".product-" + a + "-modal"),
              (this.$modal = t("#ProductScreen-" + a))),
            this.init();
        }
        return (
          (v.prototype = t.extend({}, v.prototype, {
            init: function () {
              (this.$mainSlider = t(i.mainSlider, this.$container)),
                (this.$thumbSlider = t(i.thumbSlider, this.$container)),
                (this.$firstProductImage = this.$mainSlider
                  .find("img")
                  .first()),
                (this.$formHolder = t(i.modalFormHolder + this.sectionId)),
                this.$firstProductImage.length ||
                  (this.settings.hasImages = !1),
                (this.settings.imageSetName = this.$mainSlider
                  .find("[data-set-name]")
                  .data("set-name")),
                this.inModal &&
                  (this.$container.addClass(e.isModal),
                  t("body")
                    .off("productModalOpen.ProductScreen-" + this.sectionId)
                    .off("productModalClose.ProductScreen-" + this.sectionId),
                  t("body").on(
                    "productModalOpen.ProductScreen-" + this.sectionId,
                    this.openModalProduct.bind(this)
                  ),
                  t("body").on(
                    "productModalClose.ProductScreen-" + this.sectionId,
                    this.closeModalProduct.bind(this)
                  )),
                this.inModal ||
                  (this.formSetup(),
                  this.preImageSetup(),
                  this.checkIfVideos(),
                  this.imageSetup(!0));
            },
            formSetup: function () {
              theme.settings.dynamicVariantsEnable &&
                (this.$variantSelectors = t(
                  i.formContainer,
                  this.$container
                ).find(i.singleOptionSelector)),
                this.initAjaxProductForm(),
                this.availabilitySetup(),
                this.initVariants(),
                this.settings.imageSetName && this.updateImageSet();
            },
            availabilitySetup: function () {
              var t = this.$container[0].querySelector(i.availabilityContainer);
              t && (this.storeAvailability = new theme.StoreAvailability(t));
            },
            initVariants: function () {
              var e = t(i.variantsJson, this.$container);
              if (e.length) {
                this.variantsObject = JSON.parse(e[0].innerHTML);
                var n = {
                  $container: this.$container,
                  enableHistoryState: this.settings.enableHistoryState,
                  singleOptionSelector: i.singleOptionSelector,
                  originalSelectorId: i.originalSelectorId,
                  variants: this.variantsObject,
                };
                if (
                  (t(i.variantColorSwatch, this.$container).length &&
                    t(i.variantColorSwatch, this.$container).on(
                      "change",
                      function (e) {
                        var i = t(e.currentTarget);
                        var n = i.data("color-name");
                        var a = i.data("color-index");
                        this.updateColorName(n, a);
                      }.bind(this)
                    ),
                  (this.variants = new theme.Variants(n)),
                  this.storeAvailability)
                ) {
                  var a = this.variants.currentVariant
                    ? this.variants.currentVariant.id
                    : this.variants.variants[0].id;
                  this.storeAvailability.updateContent(a),
                    this.$container.on(
                      "variantChange" + this.settings.namespace,
                      this.updateAvailability.bind(this)
                    );
                }
                this.$container
                  .on(
                    "variantChange" + this.namespace,
                    this.updateCartButton.bind(this)
                  )
                  .on(
                    "variantImageChange" + this.namespace,
                    this.updateVariantImage.bind(this)
                  )
                  .on(
                    "variantPriceChange" + this.namespace,
                    this.updatePrice.bind(this)
                  )
                  .on(
                    "variantUnitPriceChange" + this.namespace,
                    this.updateUnitPrice.bind(this)
                  ),
                  t(i.sku, this.$container).length &&
                    this.$container.on(
                      "variantSKUChange" + this.namespace,
                      this.updateSku.bind(this)
                    ),
                  (this.settings.inventory ||
                    this.settings.incomingInventory) &&
                    this.$container.on(
                      "variantChange" + this.namespace,
                      this.updateInventory.bind(this)
                    );
                var o = t(i.currentVariantJson, this.$container);
                theme.settings.dynamicVariantsEnable &&
                  o.length &&
                  ((this.currentVariantObject = JSON.parse(o[0].innerHTML)),
                  this.$variantSelectors.on(
                    "change" + this.namespace,
                    this.updateVariantAvailability.bind(this)
                  ),
                  this.setCurrentVariantAvailability(
                    this.currentVariantObject,
                    !0
                  )),
                  this.settings.imageSetName &&
                    ((this.settings.imageSetIndex = t(
                      i.formContainer,
                      this.$container
                    )
                      .find(
                        '.variant-input-wrap[data-handle="' +
                          this.settings.imageSetName +
                          '"]'
                      )
                      .data("index")),
                    this.$container.on(
                      "variantChange" + this.settings.namespace,
                      this.updateImageSet.bind(this)
                    ));
              }
            },
            initAjaxProductForm: function () {
              ("drawer" !== theme.settings.cartType &&
                "sticky" !== theme.settings.cartType) ||
                new theme.AjaxProduct(t(i.formContainer, this.$container));
            },
            updateColorName: function (e, i) {
              t("#VariantColorLabel-" + this.sectionId + "-" + i).text(e);
            },
            updateCartButton: function (n) {
              var a = n.variant;
              if (a)
                if (a.available) {
                  t(i.addToCart, this.$container)
                    .removeClass(e.disabled)
                    .prop("disabled", !1);
                  var o = t(i.addToCartText, this.$container).data(
                    "default-text"
                  );
                  t(i.addToCartText, this.$container).html(o);
                } else
                  t(i.addToCart, this.$container)
                    .addClass(e.disabled)
                    .prop("disabled", !0),
                    t(i.addToCartText, this.$container).html(
                      theme.strings.soldOut
                    );
              else
                t(i.addToCart, this.$container)
                  .addClass(e.disabled)
                  .prop("disabled", !0),
                  t(i.addToCartText, this.$container).html(
                    theme.strings.unavailable
                  );
            },
            updatePrice: function (n) {
              var a = n.variant;
              a &&
                (t(i.price, this.$container)
                  .html(
                    theme.Currency.formatMoney(
                      a.price,
                      theme.settings.moneyFormat
                    )
                  )
                  .show(),
                a.compare_at_price > a.price
                  ? (t(i.comparePrice, this.$container).html(
                      theme.Currency.formatMoney(
                        a.compare_at_price,
                        theme.settings.moneyFormat
                      )
                    ),
                    t(i.priceWrapper, this.$container).removeClass("hide"),
                    t(i.price, this.$container).addClass(e.onSale),
                    t(i.comparePriceA11y, this.$container).attr(
                      "aria-hidden",
                      "false"
                    ),
                    t(i.priceA11y, this.$container).attr(
                      "aria-hidden",
                      "false"
                    ))
                  : (t(i.priceWrapper, this.$container).addClass("hide"),
                    t(i.price, this.$container).removeClass(e.onSale),
                    t(i.comparePriceA11y, this.$container).attr(
                      "aria-hidden",
                      "true"
                    ),
                    t(i.priceA11y, this.$container).attr(
                      "aria-hidden",
                      "true"
                    )));
            },
            updateUnitPrice: function (n) {
              var a = n.variant;
              if (a && a.unit_price) {
                var o = theme.Currency.formatMoney(
                  a.unit_price,
                  theme.settings.moneyFormat
                );
                var s = theme.Currency.getBaseUnit(a);
                t(i.unitWrapper, this.$container)
                  .html(o + "/" + s)
                  .removeClass("hide")
                  .removeClass(e.visuallyHide);
              } else t(i.unitWrapper, this.$container).addClass(e.visuallyHide);
            },
            updateImageSet: function (e, i) {
              var n = e
                ? e.variant
                : this.variants
                ? this.variants.currentVariant
                : null;
              if (n) {
                var a = this.settings.imageSetIndex;
                if (a) {
                  var o = this.getImageSetName(n[a]);
                  if (i || this.settings.currentImageSet !== o) {
                    var s = this.settings.imageSetName + "_" + o;
                    if (!theme.config.bpSmall && this.settings.stackedImages)
                      return (
                        t("[data-group]", this.$container).addClass("hide"),
                        t(
                          '[data-group="' + s + '"]',
                          this.$container
                        ).removeClass("hide"),
                        this.stackedImagePositions(),
                        AOS.refresh(),
                        (this.settings.currentImageSet = o),
                        void 0
                      );
                    this.settings.slickMainInitialized &&
                      (t("[data-group]", this.$container).removeClass("hide"),
                      this.$mainSlider.slick("slickUnfilter"),
                      this.$mainSlider
                        .slick("slickFilter", '[data-group="' + s + '"]')
                        .slick("refresh"),
                      (this.settings.currentImageSet = o)),
                      theme.config.bpSmall ||
                        this.settings.stackedImages ||
                        (this.settings.slickThumbInitialized &&
                          (this.$thumbSlider.slick("slickUnfilter"),
                          this.$thumbSlider
                            .slick("slickFilter", '[data-group="' + s + '"]')
                            .slick("refresh"),
                          (this.settings.currentImageSet = o)));
                  }
                }
              }
            },
            getImageSetName: function (t) {
              return t
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/-$/, "")
                .replace(/^-/, "");
            },
            updateSku: function (e) {
              var n = e.variant;
              var a = "";
              n && (n.sku && (a = n.sku), t(i.sku, this.$container).html(a));
            },
            updateInventory: function (t) {
              var e = t.variant;
              if (
                !e ||
                !e.inventory_management ||
                "continue" === e.inventory_policy
              )
                return (
                  this.toggleInventoryQuantity(!1),
                  this.toggleIncomingInventory(!1),
                  void 0
                );
              if (
                "shopify" === e.inventory_management &&
                window.inventories &&
                window.inventories[this.sectionId]
              ) {
                variantInventoryObject =
                  window.inventories[this.sectionId][e.id];
                var i = variantInventoryObject.quantity;
                var n = !0;
                var a = !1;
                (i <= 0 || i > this.settings.inventoryThreshold) && (n = !1),
                  this.toggleInventoryQuantity(n, i),
                  !n &&
                    variantInventoryObject.incoming &&
                    i <= theme.settings.inventoryThreshold &&
                    (a = !0),
                  this.toggleIncomingInventory(
                    a,
                    e.available,
                    variantInventoryObject.next_incoming_date
                  );
              }
            },
            updateAvailability: function (t) {
              var e = t.variant;
              e && this.storeAvailability.updateContent(e.id);
            },
            toggleInventoryQuantity: function (e, n) {
              this.settings.inventory || (e = !1),
                e
                  ? t(i.inventory, this.$container)
                      .removeClass("hide")
                      .text(theme.strings.stockLabel.replace("[count]", n))
                  : t(i.inventory, this.$container).addClass("hide");
            },
            toggleIncomingInventory: function (e, n, a) {
              if ((this.settings.incomingInventory || (e = !1), e)) {
                var o = n
                  ? theme.strings.willNotShipUntil.replace("[date]", a)
                  : theme.strings.willBeInStockAfter.replace("[date]", a);
                a || (o = theme.strings.waitingForStock),
                  t(i.incomingInventory, this.$container)
                    .removeClass("hide")
                    .text(o);
              } else t(i.incomingInventory, this.$container).addClass("hide");
            },
            checkIfVideos: function () {
              var e = this.$mainSlider.find(i.productVideo);
              if (!e.length) return !1;
              var n = [];
              return (
                e.each(function () {
                  var e = t(this).data("video-type");
                  n.indexOf(e) < 0 && n.push(e);
                }),
                n.indexOf("youtube") > -1 &&
                  (theme.config.youTubeReady
                    ? this.loadYoutubeVideos(e)
                    : (theme.LibraryLoader.load("youtubeSdk"),
                      t("body").on(
                        "youTubeReady" + this.namespace,
                        function () {
                          this.loadYoutubeVideos(e);
                        }.bind(this)
                      ))),
                n.indexOf("mp4") > -1 && this.loadMp4Videos(e),
                n
              );
            },
            initVideo: function (t) {
              var e = t.data("video-type");
              var i = t.attr("id");
              "mp4" === e && "muted" === a[i].style && this.playMp4Video(i),
                "youtube" === e &&
                  n &&
                  "muted" === a[i].style &&
                  this.requestToPlayYoutubeVideo(i),
                this.inModal && this.resizeSlides();
            },
            stopVideo: function (t, e) {
              t || (this.stopYoutubeVideo(), this.stopMp4Video()),
                "youtube" === e && this.stopYoutubeVideo(t),
                "mp4" === e && this.stopMp4Video(t);
            },
            getVideoType: function (t) {
              return t.data("video-type");
            },
            getVideoId: function (t) {
              return t.attr("id");
            },
            loadMp4Videos: function (e) {
              e.each(
                function (e, i) {
                  var n = t(i);
                  if ("mp4" == n.data("video-type")) {
                    var o = n.attr("id");
                    var s = n.data("video-id");
                    a[o] = this.videos[o] = {
                      type: "mp4",
                      divId: o,
                      style: n.data("video-style"),
                    };
                  }
                }.bind(this)
              );
            },
            loadYoutubeVideos: function (e) {
              for (var i in (e.each(
                function (e, i) {
                  var n = t(i);
                  if ("youtube" == n.data("video-type")) {
                    var o = n.attr("id");
                    var s = n.data("youtube-id");
                    a[o] = this.videos[o] = {
                      type: "youtube",
                      id: o,
                      videoId: s,
                      style: n.data("video-style"),
                      loop: n.data("video-loop"),
                      attemptedToPlay: !1,
                      events: {
                        onReady: function (t) {
                          r(t, o);
                        },
                        onStateChange: function (t) {
                          u(t, o);
                        },
                      },
                    };
                  }
                }.bind(this)
              ),
              a))
                if ("youtube" === a[i].type && a.hasOwnProperty(i)) {
                  var c = t.extend({}, s, a[i]);
                  "muted" === c.style ||
                    ((c.playerVars.controls = 1), (c.playerVars.autoplay = 0)),
                    o[i] || (o[i] = new YT.Player(i, c));
                }
              n = !0;
            },
            requestToPlayYoutubeVideo: function (e, i) {
              if (theme.config.youTubeReady) {
                var n;
                if ((m(t("#" + e)), "function" != typeof o[e].playVideo))
                  return (
                    setTimeout(
                      function () {
                        this.playYoutubeVideo(e, i);
                      }.bind(this),
                      1e3
                    ),
                    void 0
                  );
                this.playYoutubeVideo(e, i);
              }
            },
            playYoutubeVideo: function (e, i) {
              var n;
              p(t("#" + e)),
                "function" == typeof o[e].playVideo && o[e].playVideo(),
                i || c(e);
            },
            stopYoutubeVideo: function (e) {
              if (theme.config.youTubeReady)
                if (e && o[e])
                  "function" == typeof o[e].pauseVideo && o[e].pauseVideo(),
                    t(window).off("scroll." + e);
                else
                  for (key in o) {
                    var i;
                    this.$container.find("#" + key).length &&
                      "function" == typeof o[key].pauseVideo &&
                      (o[key].pauseVideo(), t(window).off("scroll." + key));
                  }
            },
            playMp4Video: function (e) {
              var n = t("#" + e);
              p(n);
              var a = n[0].play();
              void 0 !== a &&
                a
                  .then(function () {})
                  .catch(function (t) {
                    n[0].setAttribute("controls", ""),
                      n
                        .closest(i.videoParent)
                        .attr("data-video-style", "unmuted");
                  });
            },
            stopMp4Video: function (e) {
              if (e) t("#" + e)[0].pause();
              else
                for (var i in a) {
                  var n;
                  if (
                    this.$container.find("#" + i).length &&
                    "mp4" === a[i].type
                  ) {
                    var o = t("#" + a[i].divId)[0];
                    o && "function" == typeof o.pause && o.pause();
                  }
                }
            },
            setCurrentVariantAvailability: function (e) {
              var n = {
                option1: [],
                option2: [],
                option3: [],
              };
              this.disableVariantGroup(
                t(i.formContainer, this.$container).find(".variant-input-wrap")
              );
              var a = this.variantsObject.filter(function (t) {
                return (
                  e.id !== t.id &&
                  ((e.option2 === t.option2 && e.option3 === t.option3) ||
                    (e.option1 === t.option1 && e.option3 === t.option3) ||
                    (e.option1 === t.option1 && e.option2 === t.option2) ||
                    void 0)
                );
              });
              var o = {
                variant: e,
              };
              for (var s in (a = Object.assign({}, o, a)))
                if (a.hasOwnProperty(s)) {
                  var r = a[s];
                  var c = r.option1;
                  var d = r.option2;
                  var l = r.option3;
                  c && -1 === n.option1.indexOf(c) && n.option1.push(c),
                    d && -1 === n.option2.indexOf(d) && n.option2.push(d),
                    l && -1 === n.option3.indexOf(l) && n.option3.push(l);
                }
              n.option1.length &&
                this.enableVariantOptionByValue(n.option1, "option1"),
                n.option2.length &&
                  this.enableVariantOptionByValue(n.option2, "option2"),
                n.option3.length &&
                  this.enableVariantOptionByValue(n.option3, "option3");
            },
            updateVariantAvailability: function (e, n, a) {
              if (n && a) {
                var o = n;
                var s = a;
              } else {
                var r = t(e.currentTarget);
                var o = r.val() ? r.val() : e.currentTarget.value;
                var s = r.data("index");
              }
              var c = this.variantsObject.filter(function (t) {
                return t[s] === o;
              });
              t(i.formContainer, this.$container)
                .find(".variant-input-wrap")
                .each(
                  function (e, i) {
                    var n = t(i);
                    var a = n.data("index");
                    if (a !== s) {
                      this.disableVariantGroup(n);
                      for (var o = 0; o < c.length; o++)
                        this.enableVariantOption(n, c[o][a]);
                    }
                  }.bind(this)
                );
            },
            disableVariantGroup: function (t) {
              "dropdown" === this.settings.variantType
                ? t.find("option").prop("disabled", !0)
                : (t.find("input").prop("disabled", !0),
                  t.find("label").toggleClass("disabled", !0));
            },
            enableVariantOptionByValue: function (e, n) {
              var a = t(i.formContainer, this.$container).find(
                '.variant-input-wrap[data-index="' + n + '"]'
              );
              for (var o = 0; o < e.length; o++)
                this.enableVariantOption(a, e[o]);
            },
            enableVariantOption: function (t, e) {
              if (
                ((e = e.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1")),
                "dropdown" === this.settings.variantType)
              )
                t.find('option[value="' + e + '"]').prop("disabled", !1);
              else {
                var i = t.find('.variant-input[data-value="' + e + '"]');
                i.find("input").prop("disabled", !1),
                  i.find("label").toggleClass("disabled", !1);
              }
            },
            preImageSetup: function () {
              this.setImageSizes(),
                this.initImageSwitch(),
                this.initImageZoom(),
                this.customMediaListners(),
                this.initModelViewerLibraries(),
                this.initShopifyXrLaunch();
            },
            imageSetup: function (e) {
              if (
                !this.$thumbSlider.length ||
                t(i.photoThumbs, this.$container).length < 2
              ) {
                var n = t(i.productImageMain, this.$container).find(
                  i.productVideo
                );
                return n.length && this.initVideo(n), void 0;
              }
              (this.settings.hasMultipleImages = !0),
                (this.settings.has3d = this.$container.find(i.media).length),
                "muted" !== this.settings.videoStyle && theme.videoModal(!0),
                e
                  ? theme.utils.promiseStylesheet().then(
                      function () {
                        this.createImageCarousels();
                      }.bind(this)
                    )
                  : this.createImageCarousels();
            },
            initImageZoom: function () {
              var e = t(i.imageContainer, this.$container);
              var n = new theme.Photoswipe(e, this.sectionId);
            },
            getThumbIndex: function (t) {
              var e;
              var i = t.closest(".product__thumb-item").index();
              return (i = i < 0 ? 0 : i);
            },
            setImageSizes: function () {
              if (this.settings.hasImages) {
                var t = this.$firstProductImage[0].currentSrc;
                t && (this.settings.imageSize = theme.Images.imageSize(t));
              }
            },
            updateVariantImage: function (e) {
              var i = e.variant;
              var n = theme.Images.getSizedImageUrl(
                i.featured_media.preview_image.src,
                this.settings.imageSize
              );
              var a = t(
                '.product__slide[data-id="' + i.featured_media.id + '"]'
              ).data("index");
              "undefined" != typeof a &&
                (!theme.config.bpSmall && this.settings.stackedImages
                  ? this.stackedScrollTo(a)
                  : this.$mainSlider.slick("slickGoTo", a));
            },
            initImageSwitch: function () {
              t(i.photoThumbs, this.$container).length &&
                t(i.photoThumbs, this.$container)
                  .on(
                    "click",
                    function (e) {
                      if (
                        (e.preventDefault(),
                        !theme.config.bpSmall && this.settings.stackedImages)
                      ) {
                        var i = this.getThumbIndex(t(e.currentTarget));
                        this.stackedScrollTo(i);
                      }
                    }.bind(this)
                  )
                  .on(
                    "focus",
                    function (n) {
                      var a = this.getThumbIndex(t(n.currentTarget));
                      theme.config.bpSmall ||
                        (this.settings.stackedImages
                          ? (t(i.photoThumbItem, this.$container).removeClass(
                              e.thumbActive
                            ),
                            this.stackedScrollTo(a))
                          : this.$mainSlider &&
                            this.settings.slickMainInitialized &&
                            this.$mainSlider.slick("slickGoTo", a));
                    }.bind(this)
                  )
                  .on(
                    "keydown",
                    function (t) {
                      13 === t.keyCode &&
                        this.$container.find(i.currentSlide).focus();
                    }.bind(this)
                  );
            },
            stackedImagesInit: function () {
              t(window).off(this.namespaceImages),
                this.stackedImagePositions(),
                this.inModal
                  ? setTimeout(
                      function () {
                        this.stackedActive(this.settings.stackedCurrent);
                      }.bind(this),
                      1e3
                    )
                  : this.stackedActive(this.settings.stackedCurrent),
                t(window).on(
                  "resize" + this.namespaceImages,
                  t.debounce(200, this.stackedImagePositions.bind(this))
                ),
                t(window).on(
                  "scroll" + this.namespaceImages,
                  t.throttle(
                    200,
                    function () {
                      var t = window.scrollY;
                      var e = this.settings.stackedImagePositions.reduce(
                        function (e, i) {
                          return Math.abs(i - t) < Math.abs(e - t) ? i : e;
                        }
                      );
                      var i = this.settings.stackedImagePositions.indexOf(e);
                      this.settings.stackedCurrent !== i &&
                        this.stackedActive(i);
                    }.bind(this)
                  )
                );
            },
            stackedImagePositions: function () {
              var e = [];
              t(i.photo, this.$container).each(function () {
                e.push(Math.round(t(this).offset().top));
              }),
                (this.settings.stackedImagePositions = e);
            },
            stackedScrollTo: function (e) {
              var n = t(i.photo, this.$container).eq(e).offset().top;
              t("html, body").animate(
                {
                  scrollTop: n,
                },
                400,
                "swing"
              );
            },
            stackedActive: function (n) {
              if (
                (t(i.photoThumbItem, this.$container)
                  .removeClass(e.thumbActive)
                  .eq(n)
                  .addClass(e.thumbActive),
                this.settings.hasVideos)
              ) {
                this.stopVideo();
                var a = t(i.photo, this.$container)
                  .eq(n)
                  .find(".product__video");
                a.length && this.initVideo(a);
              }
              if (this.settings.has3d) {
                this.$container.find(i.media).trigger("mediaHidden");
                var o = t(i.photo, this.$container).eq(n).find(i.media);
                o.length && o.trigger("mediaVisible");
              }
              this.settings.stackedCurrent = n;
            },
            createImageCarousels: function () {
              var e = this.$mainSlider.find(".starting-slide");
              var n = this._slideIndex(e);
              this.$mainSlider.off("init"),
                this.$mainSlider.off("beforeChange"),
                this.$mainSlider.on("init", this.mainSlideInit.bind(this)),
                this.$mainSlider.on(
                  "beforeChange",
                  this.beforeSlideChange.bind(this)
                ),
                this.$thumbSlider.on("init", this.thumbSlideInit.bind(this)),
                (this.mainSliderArgs = {
                  infinite: !this.settings.has3d,
                  arrows: !1,
                  dots: !0,
                  touchThreshold: 10,
                  speed: 300,
                  adaptiveHeight: !0,
                  initialSlide: n,
                  rtl: theme.config.rtl,
                  appendDots: this.$container.find(i.dotsContainer),
                }),
                (this.thumbSliderArgs = {
                  accessibility: !1,
                  rtl: theme.config.rtl,
                  initialSlide: n,
                });
              var a = this.setSliderArgs();
              this.initSliders(a),
                t("body").on(
                  "matchSmall matchLarge",
                  function () {
                    var t = this.setSliderArgs();
                    this.initSliders(t, !0);
                  }.bind(this)
                ),
                AOS && AOS.refresh();
            },
            initSliders: function (t, e) {
              this.destroyImageCarousels(),
                !theme.config.bpSmall && this.settings.stackedImages
                  ? this.stackedImagesInit()
                  : this.$mainSlider.not(".slick-initialized").slick(t.main),
                theme.config.bpSmall ||
                  this.settings.stackedImages ||
                  (this.$thumbSlider.length &&
                    this.$thumbSlider
                      .not(".slick-initialized")
                      .slick(t.thumbs)),
                this.variants &&
                  this.settings.imageSetName &&
                  this.updateImageSet(null, e);
            },
            setSliderArgs: function () {
              var e = {};
              var i = "beside" === this.$thumbSlider.data("position");
              return (
                theme.config.bpSmall
                  ? ((e.main = this.mainSliderArgs),
                    (e.thumbs = this.thumbSliderArgs))
                  : ((e.main = t.extend({}, this.mainSliderArgs, {
                      asNavFor: "#" + this.$thumbSlider.attr("id"),
                      adaptiveHeight: !i,
                      dots: !1,
                      infinite: !1,
                      fade: !0,
                    })),
                    (e.thumbs = t.extend({}, this.thumbSliderArgs, {
                      asNavFor: "#" + this.$mainSlider.attr("id"),
                      slidesToShow: i ? 3 : 5,
                      slidesToScroll: 1,
                      arrows: !1,
                      dots: !1,
                      vertical: i,
                      verticalSwiping: i,
                      focusOnSelect: !0,
                      infinite: !1,
                      customHeightMatching: i,
                      customSlideAdvancement: !0,
                    }))),
                e
              );
            },
            destroyImageCarousels: function () {
              this.$mainSlider &&
                this.settings.slickMainInitialized &&
                (this.$mainSlider.slick("slickUnfilter").slick("unslick"),
                (this.settings.slickMainInitialized = !1)),
                this.$thumbSlider &&
                  this.settings.slickThumbInitialized &&
                  (this.$thumbSlider.slick("slickUnfilter").slick("unslick"),
                  (this.settings.slickThumbInitialized = !1)),
                (this.settings.slickMainInitialized = !1),
                (this.settings.slickThumbInitialized = !1);
            },
            mainSlideInit: function (t, e) {
              var n = e.$slider.find(i.currentSlide);
              var a = n.find(i.productVideo);
              var o = n.find(i.media);
              (this.settings.slickMainInitialized = !0),
                a.length && this.initVideo(a),
                o.length && this.hideZoomOverlay(!0);
            },
            thumbSlideInit: function (t, e) {
              this.settings.slickThumbInitialized = !0;
            },
            beforeSlideChange: function (e, o, s, r) {
              var c = o.$slider;
              var d = c.find(i.currentSlide);
              var l = c.find('.slick-slide[data-slick-index="' + r + '"]');
              var h = !1;
              var u = d.find(".product__video");
              if (s !== r && u.length) {
                var m = this.getVideoType(u);
                var f = this.getVideoId(u);
                f && this.stopVideo(f, m);
              }
              var v = l.find(".product__video");
              if (v.length) {
                h = !0;
                var g = this.getVideoType(v);
                var y = this.getVideoId(v);
                y &&
                  "youtube" === g &&
                  (n
                    ? a[y] &&
                      "muted" === a[y].style &&
                      this.requestToPlayYoutubeVideo(y, !0)
                    : t("body").on(
                        "youTubeReady" + this.namespace,
                        function () {
                          a[y] &&
                            "muted" === a[y].style &&
                            this.requestToPlayYoutubeVideo(y, !0);
                        }.bind(this)
                      )),
                  y &&
                    a[y] &&
                    "muted" === a[y].style &&
                    "mp4" === g &&
                    this.playMp4Video(y),
                  y && a[y] && "muted" != a[y].style && p(t("#" + y));
              }
              l.find(".product-video-trigger").length && (h = !0);
              var b = d.find(i.media);
              b.length && b.trigger("mediaHidden");
              var w = l.find(i.media);
              w.length &&
                ((h = !0),
                w.trigger("mediaVisible"),
                l.find(".shopify-model-viewer-ui__button").attr("tabindex", 0),
                l.find(".product-single__close-media").attr("tabindex", 0)),
                this.hideZoomOverlay(h);
            },
            hideZoomOverlay: function (n) {
              n
                ? t(i.zoomButton, this.$container).addClass(e.hidden)
                : t(i.zoomButton, this.$container).removeClass(e.hidden);
            },
            resizeSlides: function () {
              this.settings.hasMultipleImages &&
                (t(window).trigger("resize.slick"),
                setTimeout(
                  function () {
                    this.$mainSlider &&
                      this.settings.slickMainInitialized &&
                      this.$mainSlider.slick("setPosition"),
                      this.$thumbSlider &&
                        this.settings.slickThumbInitialized &&
                        this.$thumbSlider.slick("setPosition");
                  }.bind(this),
                  500
                ));
            },
            _slideIndex: function (t) {
              return t.data("slick-index");
            },
            openModalProduct: function () {
              var e = !1;
              if (this.settings.modalInit)
                (e = !0),
                  !theme.config.bpSmall &&
                    this.settings.stackedImages &&
                    this.stackedActive(0);
              else {
                var i = this.$formHolder.data("url");
                var n;
                this.$formHolder.data("template") || (i += "?view=ajax"),
                  t.get(
                    i,
                    function (e) {
                      var i = t(e);
                      var n = i.find("#AddToCartForm-" + this.sectionId);
                      this.replaceModalFormHolder(this.$formHolder, n);
                      var a = i.find("#ProductSections-" + this.sectionId);
                      a.length && this.loadProductSections(a);
                      var o = i.find("#Recommendations-" + this.sectionId);
                      o.length && this.loadRelatedProducts(o);
                      var s = i.find(".index-section.social-section");
                      s.length && this.loadSocialSection(s),
                        window.SPR && (SPR.initDomEls(), SPR.loadBadges()),
                        sections.loadSubSections(this.$modal),
                        document.dispatchEvent(
                          new CustomEvent("quickview:loaded", {
                            detail: {
                              productId: this.sectionId,
                            },
                          })
                        );
                    }.bind(this)
                  ),
                  this.preImageSetup(),
                  this.loadModalContent(),
                  this.imageSetup(!1),
                  (this.settings.modalInit = !0);
              }
              document.dispatchEvent(
                new CustomEvent("quickview:open", {
                  detail: {
                    initialized: e,
                    productId: this.sectionId,
                  },
                })
              ),
                this.resizeSlides();
            },
            closeModalProduct: function () {
              this.stopVideo(),
                t("body").off(this.namespace),
                t(window).off(this.namespace);
            },
            replaceModalFormHolder: function (t, e) {
              t.replaceWith(e),
                this.formSetup(),
                Shopify &&
                  Shopify.PaymentButton &&
                  Shopify.PaymentButton.init();
            },
            loadProductSections: function (e) {
              t("#ProductSectionsHolder-" + this.sectionId).replaceWith(e);
            },
            loadRelatedProducts: function (e) {
              e.find(".screen-layer--product").remove(),
                t("#ProductRelatedHolder-" + this.sectionId).replaceWith(e);
            },
            loadSocialSection: function (e) {
              t("#SocialSectionHolder-" + this.sectionId).replaceWith(e);
            },
            loadModalContent: function () {
              var e = this.checkIfVideos();
              e &&
                e.indexOf("mp4") > -1 &&
                this.$modal
                  .find('.product__video[data-video-type="mp4"]')
                  .find(".product__video-src")
                  .each(
                    function (e, i) {
                      var n = t(i);
                      var a = n.attr("src");
                      var o = n.attr("type");
                      var s = document.createElement("source");
                      (s.src = a), (s.type = o), n.after(s);
                    }.bind(this)
                  );
            },
            initModelViewerLibraries: function () {
              var e = t(i.media, this.$container);
              e.length < 1 || theme.ProductMedia.init(e, this.sectionId);
            },
            initShopifyXrLaunch: function () {
              var i = this;
              t(document).on("shopify_xr_launch", function () {
                var n;
                t(
                  i.selectors.productMediaWrapper + ":not(." + e.hidden + ")",
                  i.$container
                ).trigger("xrLaunch");
              });
            },
            customMediaListners: function () {
              t(i.closeMedia, this.$container).on(
                "click",
                function () {
                  this.$container.find(i.media).trigger("mediaHidden");
                }.bind(this)
              ),
                this.$container
                  .find("model-viewer")
                  .on(
                    "shopify_model_viewer_ui_toggle_play",
                    function (t) {
                      this.mediaLoaded(t);
                    }.bind(this)
                  )
                  .on(
                    "shopify_model_viewer_ui_toggle_pause",
                    function (t) {
                      this.mediaUnloaded(t);
                    }.bind(this)
                  );
            },
            mediaLoaded: function (t) {
              this.$container.find(i.closeMedia).removeClass("hide"),
                this.toggleSliderSwiping(!1);
            },
            mediaUnloaded: function (t) {
              this.$container.find(i.closeMedia).addClass("hide"),
                this.toggleSliderSwiping(!0);
            },
            toggleSliderSwiping: function (t) {
              this.$mainSlider &&
                this.settings.slickMainInitialized &&
                (this.$mainSlider.slick("slickSetOption", "swipe", t),
                this.$mainSlider.slick("slickSetOption", "draggable", t),
                this.$mainSlider.slick("slickSetOption", "touchMove", t),
                this.$mainSlider.slick("slickSetOption", "accessibility", t));
            },
            onUnload: function () {
              for (var e in (this.$container.off(this.namespace),
              t("body").off(this.namespace),
              t(window).off(this.namespace).off(this.namespaceImages),
              this.destroyImageCarousels(),
              theme.ProductMedia.removeSectionModels(this.sectionId),
              this.videos))
                "youtube" === this.videos[e].type &&
                  this.videos.hasOwnProperty(e) &&
                  o[e] &&
                  delete o[e];
              AOS && AOS.refresh();
            },
          })),
          v
        );
      })()),
      (theme.Recommendations = (function () {
        function e(e) {
          var i = (this.$container = t(e));
          var n = (this.sectionId = i.attr("data-section-id"));
          (this.url = i.data("url")),
            (this.selectors = {
              recommendations: "#Recommendations-" + n,
              placeholder: ".product-recommendations-placeholder",
              sectionClass: " .product-recommendations",
              productResults: ".grid-product",
            }),
            this.init();
        }
        return (
          (e.prototype = t.extend({}, e.prototype, {
            init: function () {
              var e = t(this.selectors.recommendations);
              if (e.length && !1 !== e.data("enable")) {
                var i = e.find(this.selectors.placeholder);
                var n = e.data("product-id");
                var a = e.data("limit");
                var o =
                  this.url +
                  "?section_id=product-recommendations&limit=" +
                  a +
                  "&product_id=" +
                  n;
                i.load(
                  o + this.selectors.sectionClass,
                  function (i) {
                    theme.reinitProductGridItem(e),
                      0 ===
                        t(i)
                          .find(this.selectors.sectionClass)
                          .find(this.selectors.productResults).length &&
                        e.addClass("hide");
                  }.bind(this)
                );
              }
            },
          })),
          e
        );
      })()),
      (theme.StoreAvailability = (function () {
        var t = {
          drawerOpenBtn: ".js-drawer-open-availability",
          productTitle: "[data-availability-product-title]",
        };

        function e(t) {
          (this.container = t),
            (this.baseUrl = t.dataset.baseUrl),
            (this.productTitle = t.dataset.productName);
        }
        return (
          (e.prototype = Object.assign({}, e.prototype, {
            updateContent: function (e) {
              var i =
                this.baseUrl +
                "/variants/" +
                e +
                "/?section_id=store-availability";
              this.container.innerHTML = "";
              var n = this;
              fetch(i)
                .then(function (t) {
                  return t.text();
                })
                .then(function (e) {
                  if ("" !== e.trim()) {
                    (n.container.innerHTML = e),
                      (n.container.innerHTML =
                        n.container.firstElementChild.innerHTML);
                    var i = n.container.querySelector(".drawer");
                    if (i) {
                      var a = document.getElementById("AvailabilityDrawer");
                      if (
                        ((a.innerHTML = ""),
                        a.appendChild(i),
                        n.container.querySelector(t.drawerOpenBtn))
                      ) {
                        var o = n.container
                          .querySelector(t.drawerOpenBtn)
                          .getAttribute("aria-controls");
                        (n.drawer = new theme.Drawers(o, "availability")),
                          (a.querySelector(t.productTitle).textContent =
                            n.productTitle);
                      }
                    }
                  }
                });
            },
          })),
          e
        );
      })()),
      (theme.FeaturedCollection = (function () {
        var e = {
          scrollWrap: "[data-pagination-wrapper]",
          productContainer: "[data-product-container]",
          collectionProductContainer: "[data-collection-container]",
          product: "[data-product-grid]",
          arrows: "[data-arrow]",
        };
        var i = {
          loading: "collection-loading",
          arrowLeft: "overflow-scroller__arrow--left",
          disableScrollLeft: "overflow-scroller--disable-left",
          disableScrollRight: "overflow-scroller--disable-right",
        };

        function n(i) {
          (this.$container = t(i)),
            (this.sectionId = this.$container.attr("data-section-id")),
            (this.$scrollWrap = t(e.scrollWrap, this.$container)),
            (this.$scrollArrows = t(e.arrows, this.$container)),
            (this.namespace = ".featured-collection-" + this.sectionId),
            (this.options = {
              scrollable: this.$container.data("scrollable"),
              paginate: this.$container.data("paginate"),
            });
          var n = this.$container.data("paginate-by");
          var a = this.$container.data("collection-count");
          (this.settings = {
            url: this.$container.data("collection-url"),
            page: 1,
            pageCount: this.options.paginate ? Math.ceil(a / n) : 0,
            itemsToScroll: 3,
            gridItemWidth: this.$container.data("grid-item-width"),
          }),
            (this.state = {
              isInit: !1,
              loading: !1,
              scrollerEnabled: !1,
              loadedAllProducts: !1,
              scrollable: this.options.scrollable,
              scrollInterval: null,
              scrollSpeed: 3,
            }),
            (this.sizing = {
              scroller: 0,
              itemWidth: 0,
            }),
            theme.utils.promiseStylesheet().then(
              function () {
                this.checkVisibility(),
                  t(window).on(
                    "scroll" + this.namespace,
                    t.debounce(200, this.checkVisibility.bind(this))
                  );
              }.bind(this)
            );
        }
        return (
          (n.prototype = t.extend({}, n.prototype, {
            checkVisibility: function () {
              if (this.state.isInit)
                return (
                  0 === this.sizing.scrollSize &&
                    this.$scrollWrap.trigger("scroll" + this.namespace),
                  t(window).off("scroll" + this.namespace),
                  void 0
                );
              theme.isElementVisible(this.$container) &&
                (this.init(), (this.state.isInit = !0));
            },
            init: function () {
              new theme.HoverProductGrid(this.$container),
                this.state.scrollable &&
                  ((this.sizing = this.getScrollWidths()),
                  t(window).on(
                    "resize" + this.namespace,
                    t.debounce(200, this.handleResize.bind(this))
                  ),
                  this.toggleScrollListener(this.state.scrollable),
                  this.arrowListeners(this.state.scrollable));
            },
            reInit: function () {
              new theme.HoverProductGrid(this.$container),
                this.state.scrollable &&
                  ((this.sizing = this.getScrollWidths()),
                  this.toggleScrollListener(this.state.scrollable)),
                theme.reinitProductGridItem();
            },
            loadingState: function (t) {
              (this.state.loading = t),
                this.$container.toggleClass(i.loading, t);
            },
            getScrollWidths: function () {
              var t = this.$scrollWrap.width();
              var e = this.$scrollWrap[0].scrollWidth;
              var i = this.$scrollWrap.find(".grid__item").first().outerWidth();
              return (
                this.state.isInit || (e -= 200),
                e <= t && this.disableArrow(null, !0),
                {
                  scroller: e,
                  scrollSize: e - t,
                  itemWidth: i,
                }
              );
            },
            handleResize: function () {
              this.state.scrollable && (this.sizing = this.getScrollWidths()),
                this.toggleScrollListener(this.state.scrollable),
                this.arrowListeners(this.state.scrollable);
            },
            toggleScrollListener: function (e) {
              if (e) {
                if (this.state.scrollerEnabled) return;
                this.$scrollWrap.on(
                  "scroll" + this.namespace,
                  t.throttle(250, this.scrollCheck.bind(this))
                ),
                  (this.state.scrollerEnabled = !0);
              } else
                this.$scrollWrap.off("scroll" + this.namespace),
                  (this.state.scrollerEnabled = !1);
            },
            scrollCheck: function (t) {
              if (this.state.loading)
                return this.toggleScrollListener(!1), void 0;
              0 === this.sizing.scrollSize &&
                (this.sizing = this.getScrollWidths());
              var e = t.currentTarget.scrollLeft
                ? t.currentTarget.scrollLeft
                : 0;
              var i = Math.floor((e / this.sizing.scrollSize) * 100);
              var n = this.sizing.scrollSize - e;
              this.options.paginate &&
                !this.state.loadedAllProducts &&
                i > 50 &&
                this.getNewProducts(),
                i || (i = 0),
                this.disableArrow(i);
            },
            arrowListeners: function (t) {
              t
                ? this.$scrollArrows
                    .removeClass("hide")
                    .off(this.namespace)
                    .on("click" + this.namespace, this.arrowScroll.bind(this))
                : this.$scrollArrows.addClass("hide").off(this.namespace);
            },
            arrowScroll: function (e) {
              var n = t(e.currentTarget).hasClass(i.arrowLeft)
                ? "left"
                : "right";
              var a = theme.config.bpSmall ? 1 : 2;
              if ("mouseenter" === e.type)
                this.state.scrollInterval = setInterval(
                  function () {
                    var t = this.$scrollWrap.scrollLeft();
                    var e = "left" === n ? t - a : t + a;
                    this.$scrollWrap.scrollLeft(e);
                  }.bind(this),
                  this.state.scrollSpeed
                );
              else if ("mouseleave" === e.type)
                clearInterval(this.state.scrollInterval);
              else if ("click" === e.type) {
                clearInterval(this.state.scrollInterval);
                var o = this.$scrollWrap.scrollLeft();
                var s = this.sizing.itemWidth * this.settings.itemsToScroll;
                var r = "left" === n ? o - s : o + s;
                this.$scrollWrap.stop().animate(
                  {
                    scrollLeft: r,
                  },
                  400,
                  "swing"
                );
              }
              r <= 0 && this.disableArrow(r);
            },
            disableArrow: function (t, e) {
              return (
                this.$scrollArrows
                  .removeClass(i.disableScrollRight)
                  .removeClass(i.disableScrollLeft),
                e
                  ? (this.$scrollArrows
                      .addClass(i.disableScrollRight)
                      .addClass(i.disableScrollLeft),
                    void 0)
                  : t <= 0
                  ? (this.$scrollArrows.addClass(i.disableScrollLeft), void 0)
                  : t >= 96
                  ? (this.$scrollArrows.addClass(i.disableScrollRight), void 0)
                  : void 0
              );
            },
            getNewProducts: function () {
              this.loadingState(!0);
              var i = this.settings.page + 1;
              var n = this.settings.gridItemWidth;
              if (i > this.settings.pageCount)
                return (
                  this.loadingState(!1),
                  (this.state.loadedAllProducts = !0),
                  void 0
                );
              var a = this.settings.url + "?page=" + i;
              t.get(
                a,
                function (i) {
                  var a;
                  var o = t(i).find(
                    e.collectionProductContainer + " .grid-product"
                  );
                  o.each(function () {
                    t(this).addClass(n);
                  }),
                    t(e.productContainer, this.$container).append(o),
                    this.ajaxSuccess();
                }.bind(this)
              );
            },
            ajaxSuccess: function () {
              this.loadingState(!1),
                (this.settings.page = this.settings.page + 1),
                this.reInit();
            },
            forceReload: function () {
              this.onUnload(), this.init();
            },
            onLoad: function () {
              theme.QuickShopScreens.reInit(this.$container);
            },
            onUnload: function () {
              t(window).off(this.namespace).trigger("resize"),
                this.$scrollWrap.off(this.namespace),
                theme.QuickShopScreens.unload(this.$container);
            },
          })),
          n
        );
      })()),
      (theme.Collection = (function () {
        var e = !1;
        var i = {
          sortSelect: "#SortBy",
        };
        var n = {
          sortBy: "data-default-sortby",
        };

        function a(i) {
          var n;
          (this.container = i),
            (this.sectionId = t(i).attr("data-section-id")),
            (this.namespace = ".collection-" + this.sectionId),
            t(".collection-hero").length
              ? this.checkIfNeedReload()
              : theme.settings.overlayHeader &&
                theme.headerNav.disableOverlayHeader(),
            t(window).on(
              "popstate",
              function (t) {
                if (t) {
                  if (location.href.indexOf(location.pathname) >= 0) return !0;
                  theme.CollectionAjaxFilter(location.href).then(function () {
                    e = !1;
                  });
                }
              }.bind(this)
            ),
            this.init();
        }
        return (
          (a.prototype = t.extend({}, a.prototype, {
            init: function () {
              (this.$container = t(this.container)),
                (this.sectionId = this.$container.attr("data-section-id")),
                (this.$sortSelect = t(i.sortSelect)),
                this.$sortSelect.on("change", this.onSortChange.bind(this)),
                (this.defaultSort = this.getDefaultSortValue()),
                new theme.HoverProductGrid(this.$container),
                this.initParams(),
                this.sortTags();
            },
            initParams: function () {
              if (((this.queryParams = {}), location.search.length)) {
                var t;
                var e = location.search.substr(1).split("&");
                for (var i = 0; i < e.length; i++)
                  (t = e[i].split("=")).length > 1 &&
                    (this.queryParams[decodeURIComponent(t[0])] =
                      decodeURIComponent(t[1]));
              }
            },
            getSortValue: function () {
              return this.$sortSelect.val() || this.defaultSort;
            },
            getDefaultSortValue: function () {
              return this.$sortSelect.attr(n.sortBy);
            },
            onSortChange: function () {
              (this.queryParams.sort_by = this.getSortValue()),
                this.queryParams.page && delete this.queryParams.page,
                (window.location.search = t.param(this.queryParams));
            },
            sortTags: function () {
              var e = t("#SortTags");
              e.length &&
                e.on("change", function () {
                  location.href = t(this).val();
                });
            },
            checkIfNeedReload: function () {
              Shopify.designMode &&
                theme.settings.overlayHeader &&
                (t(".header-wrapper").hasClass("header-wrapper--overlay") ||
                  location.reload());
            },
            forceReload: function () {
              this.onUnload(), this.init();
            },
            onUnload: function () {
              t(window).off(this.namespace),
                this.$container.off(this.namespace);
            },
          })),
          a
        );
      })()),
      (theme.CollectionFilter = (function () {
        var e = !1;
        var i = {
          tags: ".tag a",
          activeTagList: ".tag-list--active-tags",
        };
        var n = {
          activeTag: "tag--active",
          removeTagParent: "tag--remove",
        };

        function a(e) {
          (this.$container = t(e)),
            (this.sectionId = this.$container.attr("data-section-id")),
            (this.namespace = ".collection-filter-" + this.sectionId),
            (this.settings = {
              combineTags: this.$container.data("combine-tags"),
            }),
            this.initTagAjax();
        }
        return (
          (a.prototype = t.extend({}, a.prototype, {
            initTagAjax: function () {
              t("body").on(
                "click",
                i.tags,
                function (a) {
                  var o;
                  if (
                    !(o = t(this)).hasClass("no-ajax") &&
                    (a.preventDefault(), !e)
                  ) {
                    var o;
                    e = !0;
                    var s = (o = t(a.currentTarget)).parent();
                    var r = o.attr("href");
                    this.settings.combineTags
                      ? s.hasClass(n.activeTag)
                        ? s.removeClass(n.activeTag)
                        : (s.hasClass(n.removeTagParent)
                            ? s.remove()
                            : t(i.activeTagList).append(
                                '<li class="tag tag--remove"><a class="btn btn--small js-no-transition">' +
                                  o.text() +
                                  "</a></li>"
                              ),
                          s.addClass(n.activeTag))
                      : (t(i.tags).parent().removeClass(n.activeTag),
                        s.addClass(n.activeTag)),
                      history.pushState({}, "", r),
                      t(".grid-product").addClass("unload"),
                      theme.CollectionAjaxFilter(r).then(function () {
                        e = !1;
                      });
                  }
                }.bind(this)
              );
            },
          })),
          a
        );
      })()),
      (theme.CollectionAjaxFilter = function (e) {
        var i = {
          filterWrapper: ".collection-filter__wrapper",
          productsWrapper: "#CollectionAjaxContent",
        };
        var n;
        return (
          (e = -1 === e.indexOf("?") ? e + "?view=ajax" : e + "&view=ajax"),
          t.Deferred(function (n) {
            t.get(e, function (e) {
              var a = t(e);
              var o = a.find(i.filterWrapper);
              t(i.filterWrapper).replaceWith(o);
              var s = a.find(i.productsWrapper);
              t(i.productsWrapper).replaceWith(s),
                sections.reinitSection("collection-template"),
                theme.QuickShopScreens.reInit(t(i.productsWrapper)),
                theme.reinitProductGridItem(t(i.productsWrapper)),
                n.resolve();
            });
          })
        );
      }),
      (theme.HeaderSection = (function () {
        function e(e) {
          var i = (this.$container = t(e));
          var n = (this.sectionId = i.attr("data-section-id"));
          this.initDrawers(),
            theme.headerNav.init(),
            theme.slideNav.init(),
            sections.reinitSection("slideshow-section");
        }
        return (
          (e.prototype = t.extend({}, e.prototype, {
            initDrawers: function () {
              t(document.body).hasClass("template-cart")
                ? new theme.AjaxCart("CartPage")
                : "drawer" === theme.settings.cartType &&
                  new theme.AjaxCart("CartDrawer");
            },
            onUnload: function () {
              theme.headerNav.unload(), theme.slideNav.unload();
            },
          })),
          e
        );
      })()),
      (theme.FooterSection = (function () {
        var e = {
          disclosureLocale: "[data-disclosure-locale]",
          disclosureCurrency: "[data-disclosure-currency]",
        };

        function i(e) {
          var i = (this.$container = t(e));
          (this.cache = {}),
            this.cacheSelectors(),
            this.cache.$localeDisclosure.length &&
              (this.localeDisclosure = new theme.Disclosure(
                this.cache.$localeDisclosure
              )),
            this.cache.$currencyDisclosure.length &&
              (this.currencyDisclosure = new theme.Disclosure(
                this.cache.$currencyDisclosure
              ));
        }
        return (
          (i.prototype = t.extend({}, i.prototype, {
            cacheSelectors: function () {
              this.cache = {
                $localeDisclosure: this.$container.find(e.disclosureLocale),
                $currencyDisclosure: this.$container.find(e.disclosureCurrency),
              };
            },
            onUnload: function () {
              this.cache.$localeDisclosure.length &&
                this.localeDisclosure.unload(),
                this.cache.$currencyDisclosure.length &&
                  this.currencyDisclosure.unload();
            },
          })),
          i
        );
      })()),
      (theme.FeaturedContentSection = (function () {
        function e() {
          t(".rte").find("a:not(:has(img))").addClass("text-link");
        }
        return e;
      })()),
      (theme.slideshows = {}),
      (theme.SlideshowSection = (function () {
        function e(e) {
          var i = (this.$container = t(e));
          var n = i.parent();
          var a = i.attr("data-section-id");
          var o = (this.slideshow = "#Slideshow-" + a);
          var s = t(e).find(".hero");
          s.length && theme.loadImageSection(s), this.init();
        }
        return (
          (e.prototype = t.extend({}, e.prototype, {
            init: function () {
              var e = {
                arrows: t(this.slideshow).data("arrows"),
                dots: t(this.slideshow).data("dots"),
                pauseOnHover: !0,
              };
              theme.slideshows[this.slideshow] = new theme.Slideshow(
                this.slideshow,
                e
              );
            },
            forceReload: function () {
              this.onUnload(), this.init();
            },
            onUnload: function () {
              theme.slideshows[this.slideshow].destroy(),
                delete theme.slideshows[this.slideshow];
            },
            onSelect: function () {
              t(this.slideshow).slick("slickPause");
            },
            onDeselect: function () {
              t(this.slideshow).slick("slickPlay");
            },
            onBlockSelect: function (e) {
              var i = t(this.slideshow);
              var n;
              var a = t(
                ".slideshow__slide--" + e.detail.blockId + ":not(.slick-cloned)"
              ).data("slick-index");
              i.slick("slickGoTo", a).slick("slickPause");
            },
            onBlockDeselect: function () {
              t(this.slideshow).slick("slickPlay");
            },
          })),
          e
        );
      })());
    (theme.HeroAnimated = (function () {
      var e = {
        active: "animated__slide--active",
        inactive: "animated__slide--inactive",
      };

      function i(e) {
        var i = (this.$container = t(e));
        var n = i.parent();
        var a = i.attr("data-section-id");
        var o = i.data("count");
        var s = ".hero-animated-" + a;
        var r = t(e).find(".hero");
        if (
          (r.length && theme.loadImageSection(r),
          (this.$allImages = i.find(".animated__slide")),
          (this.state = {
            active: !1,
            activeIndex: 0,
          }),
          1 === o)
        )
          return this.setFades(!0), void 0;
        this.interval,
          (this.intervalSpeed = i.data("interval")),
          (this.maxIndex = o - 1),
          theme.utils.promiseStylesheet().then(
            function () {
              this.checkVisibility(),
                t(window).on(
                  "scroll" + s,
                  t.throttle(300, this.checkVisibility.bind(this))
                );
            }.bind(this)
          );
      }
      return (
        (i.prototype = t.extend({}, i.prototype, {
          checkVisibility: function () {
            if (!theme.isElementVisible(this.$container))
              return (
                (this.state.active = !1), clearInterval(this.interval), void 0
              );
            this.state.active || this.initInterval();
          },
          initInterval: function () {
            (this.state.active = !0),
              this.setFades(!0),
              (this.interval = setInterval(
                function () {
                  this.setFades();
                }.bind(this),
                this.intervalSpeed
              ));
          },
          setFades: function (t) {
            var i =
              this.state.activeIndex === this.maxIndex
                ? 0
                : this.state.activeIndex + 1;
            t && (i = this.state.activeIndex),
              t ||
                this.$allImages
                  .eq(this.state.activeIndex)
                  .removeClass(e.active)
                  .addClass(e.inactive),
              this.$allImages.eq(i).removeClass(e.inactive).addClass(e.active),
              (this.state.activeIndex = i);
          },
          onUnload: function () {
            clearInterval(this.interval);
          },
        })),
        i
      );
    })()),
      (theme.VideoSection = (function () {
        var e;
        var i = [];
        var n = [];
        var a = {
          width: 1280,
          height: 720,
          playerVars: {
            autohide: 0,
            branding: 0,
            cc_load_policy: 0,
            controls: 0,
            fs: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            playsinline: 1,
            quality: "hd720",
            rel: 0,
            showinfo: 0,
            wmode: "opaque",
          },
        };
        var o = !1;
        var s = {
          byline: !1,
          title: !1,
          portrait: !1,
          loop: !0,
        };
        var r = {
          videoParent: ".video-parent-section",
        };
        var c = {
          loading: "loading",
          loaded: "loaded",
          interactable: "video-interactable",
        };

        function d(e) {
          var i = (this.$container = t(e));
          var n = (this.sectionId = i.attr("data-section-id"));
          var a = (this.youtubePlayerId = "YouTubeVideo-" + this.sectionId);
          this.namespace = "." + a;
          var o = (this.vimeoPlayerId = "Vimeo-" + this.sectionId);
          var s = (this.$vimeoTrigger = t("#VimeoTrigger-" + this.sectionId));
          var r = "Mp4Video-" + this.sectionId;
          var c = t("#" + a);
          var d = t("#" + o);
          var h = t("#" + r);
          (this.vimeoPlayer = []),
            c.length &&
              ((this.youtubeVideoId = c.data("video-id")),
              this.initYoutubeVideo()),
            d.length &&
              ((this.vimeoVideoId = d.data("video-id")), this.initVimeoVideo()),
            h.length &&
              l(r)
                .then(function () {
                  g(h);
                })
                .catch(function (t) {
                  h.attr("controls", ""), g(h), y(h);
                });
        }

        function l(t) {
          return document.querySelector("#" + t).play();
        }

        function h(e, i) {
          var a = t("#" + i);
          var o = a.attr("id");
          n[o] = e.target;
          var s = n[o];
          v(a),
            n[o].mute(),
            a.attr("tabindex", "-1"),
            theme.utils.promiseStylesheet().then(function () {
              u(o),
                t(window).on(
                  "scroll." + o,
                  {
                    id: o,
                  },
                  t.throttle(150, u)
                );
            });
        }

        function u(e) {
          var i;
          if (e) {
            if ("string" == typeof e) i = e;
            else {
              if (!e || !e.data) return;
              i = e.data.id;
            }
            theme.isElementVisible(t("#" + i)) ? m(i) : p(i);
          }
        }

        function m(t) {
          n[t] && "function" == typeof n[t].playVideo && n[t].playVideo();
        }

        function p(t) {
          n[t] && "function" == typeof n[t].pauseVideo && n[t].pauseVideo();
        }

        function f(e, a) {
          var o = t("#" + a);
          var s = o.attr("id");
          var r = n[s];
          switch (e.data) {
            case -1:
              i[s].attemptedToPlay && (g(o), y(o));
              break;
            case 0:
              r.playVideo();
              break;
            case 1:
              g(o);
              break;
            case 3:
              i[s].attemptedToPlay = !0;
              break;
          }
        }

        function v(t) {
          t.closest(r.videoParent).addClass(c.loading);
        }

        function g(t) {
          t.closest(r.videoParent).removeClass(c.loading).addClass(c.loaded);
        }

        function y(t) {
          t.closest(r.videoParent).addClass(c.interactable);
        }
        return (
          (d.prototype = t.extend({}, d.prototype, {
            initYoutubeVideo: function () {
              (i[this.youtubePlayerId] = {
                id: this.youtubePlayerId,
                videoId: this.youtubeVideoId,
                type: "youtube",
                attemptedToPlay: !1,
                events: {
                  onReady: function (t) {
                    h(t, this.youtubePlayerId);
                  }.bind(this),
                  onStateChange: function (t) {
                    f(t, this.youtubePlayerId);
                  }.bind(this),
                },
              }),
                e
                  ? this.loadYoutubeVideo()
                  : (theme.LibraryLoader.load("youtubeSdk"),
                    t("body").on(
                      "youTubeReady" + this.namespace,
                      this.loadYoutubeVideo.bind(this)
                    ));
            },
            loadYoutubeVideo: function () {
              var o = t.extend({}, a, i[this.youtubePlayerId]);
              (o.playerVars.controls = 0),
                (n[this.youtubePlayerId] = new YT.Player(
                  this.youtubePlayerId,
                  o
                )),
                (e = !0);
            },
            initVimeoVideo: function () {
              var e;
              (i[this.vimeoPlayerId] = {
                divId: this.vimeoPlayerId,
                id: this.vimeoVideoId,
                type: "vimeo",
              }),
                v(t("#" + this.vimeoPlayerId)),
                this.$vimeoTrigger.on(
                  "click",
                  +this.namespace,
                  function (t) {
                    this.requestToPlayVimeoVideo(this.vimeoPlayerId);
                  }.bind(this)
                ),
                o
                  ? this.loadVimeoVideo()
                  : (window.loadVimeo(),
                    t("body").on(
                      "vimeoReady" + this.namespace,
                      this.loadVimeoVideo.bind(this)
                    ));
            },
            loadVimeoVideo: function () {
              var e = t.extend({}, s, i[this.vimeoPlayerId]);
              var n;
              ((this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(
                i[this.vimeoPlayerId].divId,
                e
              )),
              (o = !0),
              theme.config.bpSmall)
                ? g(t("#" + this.vimeoPlayerId))
                : this.requestToPlayVimeoVideo(this.vimeoPlayerId);
            },
            requestToPlayVimeoVideo: function (e) {
              if (!o)
                return (
                  t("body").on(
                    "vimeoReady" + this.namespace,
                    function () {
                      this.playVimeoVideo(e);
                    }.bind(this)
                  ),
                  void 0
                );
              this.playVimeoVideo(e);
            },
            playVimeoVideo: function (e) {
              var i;
              this.vimeoPlayer[e].play(),
                this.vimeoPlayer[e].setVolume(0),
                g(t("#" + e));
            },
            onUnload: function (e) {
              var i;
              var a =
                "YouTubeVideo-" + e.target.id.replace("shopify-section-", "");
              n[a] && n[a].destroy(),
                t(window).off("scroll" + this.namespace),
                t("body").off("vimeoReady" + this.namespace);
            },
          })),
          d
        );
      })()),
      (theme.Testimonials = (function () {
        var e = 0;
        var i = {
          accessibility: !0,
          arrows: !1,
          dots: !0,
          autoplay: !1,
          touchThreshold: 20,
          rtl: theme.config.rtl,
          slidesToShow: 3,
          slidesToScroll: 3,
        };

        function n(n) {
          var a;
          var o = (this.$container = t(n)).attr("data-section-id");
          var s = (this.wrapper = ".testimonials-wrapper");
          var r = (this.slider = "#Testimonials-" + o);
          var c = t(r);
          this.sliderActive = !1;
          var d = t.extend({}, i, {
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: !0,
          });
          (e = c.data("count")) < i.slidesToShow &&
            ((i.slidesToShow = e), (i.slidesToScroll = e)),
            c.on("init", this.a11y.bind(this)),
            theme.config.bpSmall ? this.init(c, d) : this.init(c, i),
            t("body").on(
              "matchSmall",
              function () {
                this.init(c, d);
              }.bind(this)
            ),
            t("body").on(
              "matchLarge",
              function () {
                this.init(c, i);
              }.bind(this)
            );
        }
        return (
          (n.prototype = t.extend({}, n.prototype, {
            onUnload: function () {
              t(this.slider, this.wrapper).slick("unslick");
            },
            onBlockSelect: function (e) {
              var i;
              var n = t(
                ".testimonials-slide--" +
                  e.detail.blockId +
                  ":not(.slick-cloned)"
              ).data("slick-index");
              t(this.slider, this.wrapper).slick("slickGoTo", n);
            },
            init: function (e, i) {
              this.sliderActive &&
                (e.slick("unslick"), (this.sliderActive = !1)),
                e.slick(i),
                (this.sliderActive = !0),
                AOS && AOS.refresh(),
                t("body").on("productModalClose", function () {
                  e.slick("refresh");
                });
            },
            a11y: function (e, i) {
              var n = i.$list;
              var a = t(this.wrapper, this.$container);
              n.removeAttr("aria-live"),
                a.on("focusin", function (t) {
                  a.has(t.target).length && n.attr("aria-live", "polite");
                }),
                a.on("focusout", function (t) {
                  a.has(t.target).length && n.removeAttr("aria-live");
                });
            },
          })),
          n
        );
      })()),
      (theme.NewsletterPopup = (function () {
        function e(e) {
          var i = (this.$container = t(e));
          var n = i.attr("data-section-id");
          if (
            ((this.cookieName = "newsletter-" + n),
            i.length && "/challenge" !== window.location.pathname)
          ) {
            if (
              ((this.data = {
                secondsBeforeShow: i.data("delay-seconds"),
                daysBeforeReappear: i.data("delay-days"),
                cookie: Cookies.get(this.cookieName),
                testMode: i.data("test-mode"),
              }),
              (this.modal = new theme.Modals(
                "NewsletterPopup-" + n,
                "newsletter-popup-modal"
              )),
              (i.find(".errors").length || i.find(".note--success").length) &&
                this.modal.open(),
              i.find(".note--success").length)
            )
              return this.closePopup(!0), void 0;
            t("body").on(
              "modalClose." + i.attr("id"),
              this.closePopup.bind(this)
            ),
              (this.data.cookie && !this.data.testMode) ||
                this.initPopupDelay();
          }
        }
        return (
          (e.prototype = t.extend({}, e.prototype, {
            initPopupDelay: function () {
              setTimeout(
                function () {
                  this.modal.open();
                }.bind(this),
                1e3 * this.data.secondsBeforeShow
              );
            },
            closePopup: function (t) {
              if (this.data.testMode)
                return (
                  Cookies.remove(this.cookieName, {
                    path: "/",
                  }),
                  void 0
                );
              var e = t ? 200 : this.data.daysBeforeReappear;
              Cookies.set(this.cookieName, "opened", {
                path: "/",
                expires: e,
              });
            },
            onLoad: function () {
              this.modal.open();
            },
            onSelect: function () {
              this.modal.open();
            },
            onDeselect: function () {
              this.modal.close();
            },
            onUnload: function () {},
          })),
          e
        );
      })()),
      (theme.Maps = (function () {
        var e = {
          zoom: 14,
        };
        var i = null;
        var n = [];
        var a = {
          addressNoResults: theme.strings.addressNoResults,
          addressQueryLimit: theme.strings.addressQueryLimit,
          addressError: theme.strings.addressError,
          authError: theme.strings.authError,
        };
        var o = {
          section: '[data-section-type="map"]',
          map: "[data-map]",
          mapOverlay: "[data-map-overlay]",
        };
        var s = {
          mapError: "map-section--load-error",
          errorMsg: "map-section__error errors text-center",
        };

        function r(e) {
          (this.$container = t(e)),
            (this.sectionId = this.$container.attr("data-section-id")),
            (this.namespace = ".map-" + this.sectionId),
            (this.$map = this.$container.find(o.map)),
            (this.key = this.$map.data("api-key")),
            this.key &&
              (this.checkVisibility(),
              t(window).on(
                "scroll" + this.namespace,
                t.throttle(50, this.checkVisibility.bind(this))
              ));
        }

        function c() {
          t.each(n, function (t, e) {
            e.createMap();
          });
        }

        function d(e) {
          var i = t.Deferred();
          var n = new google.maps.Geocoder();
          var a = e.data("address-setting");
          return (
            n.geocode(
              {
                address: a,
              },
              function (t, e) {
                e !== google.maps.GeocoderStatus.OK && i.reject(e),
                  i.resolve(t);
              }
            ),
            i
          );
        }
        return (
          (window.gm_authFailure = function () {
            Shopify.designMode &&
              (t(o.section).addClass(s.mapError),
              t(o.map).remove(),
              t(o.mapOverlay).after(
                '<div class="' +
                  s.errorMsg +
                  '">' +
                  theme.strings.authError +
                  "</div>"
              ));
          }),
          (r.prototype = t.extend({}, r.prototype, {
            prepMapApi: function () {
              "loaded" === i
                ? this.createMap()
                : (n.push(this),
                  "loading" !== i &&
                    ((i = "loading"),
                    ("undefined" != typeof window.google &&
                      "undefined" != typeof window.google.maps) ||
                      t
                        .getScript(
                          "https://maps.googleapis.com/maps/api/js?key=" +
                            this.key
                        )
                        .then(function () {
                          (i = "loaded"), c();
                        })));
            },
            createMap: function () {
              var i = this.$map;
              return d(i)
                .then(
                  function (n) {
                    var a = {
                      zoom: e.zoom,
                      backgroundColor: "none",
                      center: n[0].geometry.location,
                      draggable: !1,
                      clickableIcons: !1,
                      scrollwheel: !1,
                      disableDoubleClickZoom: !0,
                      disableDefaultUI: !0,
                    };
                    var o = (this.map = new google.maps.Map(i[0], a));
                    var s = (this.center = o.getCenter());
                    var r = new google.maps.Marker({
                      map: o,
                      position: o.getCenter(),
                    });
                    google.maps.event.addDomListener(
                      window,
                      "resize",
                      t.debounce(250, function () {
                        google.maps.event.trigger(o, "resize"),
                          o.setCenter(s),
                          i.removeAttr("style");
                      })
                    );
                  }.bind(this)
                )
                .fail(function () {
                  var t;
                  switch (status) {
                    case "ZERO_RESULTS":
                      t = a.addressNoResults;
                      break;
                    case "OVER_QUERY_LIMIT":
                      t = a.addressQueryLimit;
                      break;
                    case "REQUEST_DENIED":
                      t = a.authError;
                      break;
                    default:
                      t = a.addressError;
                      break;
                  }
                  Shopify.designMode &&
                    i
                      .parent()
                      .addClass(s.mapError)
                      .html('<div class="' + s.errorMsg + '">' + t + "</div>");
                });
            },
            checkVisibility: function () {
              theme.isElementVisible(this.$container, 600) &&
                (this.prepMapApi(), t(window).off(this.namespace));
            },
            onUnload: function () {
              0 !== this.$map.length &&
                google.maps.event.clearListeners(this.map, "resize");
            },
          })),
          r
        );
      })()),
      (theme.Blog = (function () {
        function e(t) {
          this.tagFilters();
        }
        return (
          (e.prototype = t.extend({}, e.prototype, {
            tagFilters: function () {
              var e = t("#BlogTagFilter");
              e.length &&
                e.on("change", function () {
                  location.href = t(this).val();
                });
            },
            onUnload: function () {},
          })),
          e
        );
      })()),
      (theme.Photoswipe = (function () {
        var e = {
          trigger: ".product__photo-zoom",
          images: ".photoswipe__image",
          activeImage: ".gallery .slick-active .photoswipe__image",
        };

        function i(t, e) {
          (this.$container = t),
            (this.sectionId = e),
            (this.namespace = ".photoswipe-" + this.sectionId),
            this.gallery,
            this.$images,
            (this.inSlideshow = !1),
            "false" !== t.attr("data-zoom") &&
              ("true" === t.attr("data-has-slideshow") &&
                (this.inSlideshow = !0),
              this.init());
        }
        return (
          (i.prototype = t.extend({}, i.prototype, {
            init: function () {
              var i = this.$container.find(e.trigger);
              this.$images = this.$container.find(e.images);
              var n = [];
              i.on(
                "click" + this.namespace,
                function (i) {
                  if (
                    ((n = this.getImageData()),
                    this.inSlideshow || theme.config.bpSmall)
                  )
                    var a = this.$container.find(e.activeImage).data("index");
                  else var a = t(i.currentTarget).data("index");
                  this.initGallery(n, a);
                }.bind(this)
              );
            },
            getImageData: function () {
              var e = !1;
              var i = [];
              var n = {};
              return (
                this.$images.each(function () {
                  var e = !0;
                  var n;
                  var a = {
                    msrc: t(this).prop("currentSrc") || t(this).prop("src"),
                    src: t(this).data("photoswipe-src"),
                    w: t(this).data("photoswipe-width"),
                    h: t(this).data("photoswipe-height"),
                    el: t(this)[0],
                    initialZoomLevel: 0.5,
                  };
                  i.push(a);
                }),
                i
              );
            },
            initGallery: function (t, e) {
              var i = document.querySelectorAll(".pswp")[0];
              var n = {
                allowPanToNext: !1,
                captionEl: !1,
                closeOnScroll: !1,
                counterEl: !1,
                history: !1,
                index: e - 1,
                pinchToClose: !1,
                preloaderEl: !1,
                scaleMode: "zoom",
                shareEl: !1,
                tapToToggleControls: !1,
                getThumbBoundsFn: function (e) {
                  var i =
                    window.pageYOffset || document.documentElement.scrollTop;
                  var n;
                  var a = t[e].el.getBoundingClientRect();
                  return {
                    x: a.left,
                    y: a.top + i,
                    w: a.width,
                  };
                },
              };
              (this.gallery = new PhotoSwipe(i, PhotoSwipeUI_Default, t, n)),
                this.gallery.init(),
                this.gallery.listen("afterChange", this.afterChange.bind(this));
            },
            afterChange: function () {
              if (this.inSlideshow) {
                var e = t("#ProductPhotos-" + this.sectionId);
                if (e.hasClass("slick-initialized")) {
                  var i = this.gallery.getCurrentIndex();
                  e.slick("slickGoTo", i);
                }
              }
            },
          })),
          i
        );
      })()),
      (window.onYouTubeIframeAPIReady = function () {
        (theme.config.youTubeReady = !0), t("body").trigger("youTubeReady");
      }),
      (window.loadVimeo = function () {
        if (!theme.config.vimeoLoading && !theme.config.vimeoReady) {
          theme.config.vimeoLoading = !0;
          var i = document.createElement("script");
          i.src = "https://player.vimeo.com/api/player.js";
          var n = document.getElementsByTagName("script")[0];
          n.parentNode.insertBefore(i, n),
            e()
              .then(function () {
                (theme.config.vimeoReady = !0),
                  (theme.config.vimeoLoading = !1),
                  t("body").trigger("vimeoReady");
              })
              .fail(function () {});
        }
      }),
      (theme.init = function () {
        theme.setGlobals(),
          theme.pageTransitions(),
          theme.QuickShopScreens.init(),
          theme.articleImages.init(),
          theme.collapsibles.init(),
          "sticky" === theme.settings.cartType && new theme.StickyCart.init(),
          theme.customerTemplates.init(),
          theme.videoModal(),
          theme.rte.init(),
          t(document.documentElement).on("keyup.tab", function (e) {
            9 === e.keyCode &&
              (t(document.documentElement).addClass("tab-outline"),
              t(document.documentElement).off("keyup.tab"));
          }),
          window.addEventListener("pageshow", function (t) {
            t.persisted && theme.refreshCart();
          }),
          performance &&
            2 === performance.navigation.type &&
            theme.refreshCart();
      }),
      (theme.refreshCart = function () {
        "sticky" === theme.settings.cartType &&
          theme.StickyCart &&
          t.getJSON("/cart.js").then(function (t) {
            theme.StickyCart.refresh(t);
          });
      }),
      (theme.setGlobals = function () {
        (theme.config.hasSessionStorage = theme.isSessionStorageSupported()),
          theme.config.isTouch && t("body").addClass("supports-touch"),
          enquire.register(theme.config.mediaQuerySmall, {
            match: function () {
              (theme.config.bpSmall = !0), t("body").trigger("matchSmall");
            },
            unmatch: function () {
              (theme.config.bpSmall = !1), t("body").trigger("unmatchSmall");
            },
          }),
          enquire.register(theme.config.mediaQuerySmallUp, {
            match: function () {
              t("body").trigger("matchLarge");
            },
            unmatch: function () {
              t("body").trigger("unmatchLarge");
            },
          });
      }),
      (theme.loadImageSection = function (t) {
        function e() {
          t.removeClass("loading").addClass("loaded");
        }

        function i() {
          return t.find(".lazyloaded").length;
        }
        if (t.find("svg").length) return e(), void 0;
        if (i() > 0) return e(), void 0;
        var n = setInterval(function () {
          i() > 0 && (clearInterval(n), e());
        }, 80);
      }),
      (theme.isSessionStorageSupported = function () {
        if (window.self !== window.top) return !1;
        var t = "test";
        var e = window.sessionStorage;
        try {
          return e.setItem(t, "1"), e.removeItem(t), !0;
        } catch (t) {
          return !1;
        }
      }),
      (theme.isElementVisible = function (t, e) {
        var i = t[0].getBoundingClientRect();
        var n = window.innerHeight || document.documentElement.clientHeight;
        return (
          (e = e || 0),
          null !== t[0].offsetParent &&
            i.bottom >= 0 - e / 1.5 &&
            i.right >= 0 &&
            i.top <= n + e &&
            i.left <=
              (window.innerWidth || document.documentElement.clientWidth)
        );
      }),
      (theme.pageTransitions = function () {
        1 == t("body").data("transitions") &&
          (theme.config.isSafari &&
            t("a").on("click", function () {
              window.setTimeout(function () {
                t("body").removeClass("unloading");
              }, 1200);
            }),
          t(
            'a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"], a[download]'
          ).each(function () {
            t(this).addClass("js-no-transition");
          }),
          t("a:not(.js-no-transition)").on("click", function (e) {
            if (e.metaKey) return !0;
            var i = t(this).attr("href");
            if (i.indexOf(location.pathname) >= 0 && i.indexOf("#") >= 0)
              return !0;
            e.preventDefault(),
              t("body").addClass("unloading"),
              window.setTimeout(function () {
                location.href = i;
              }, 50);
          }));
      }),
      (window.onpageshow = function (e) {
        var i;
        e.persisted &&
          (t("body").removeClass("unloading"),
          t(".cart__checkout").removeClass("btn--loading"),
          t("#StickySubmit").removeClass("btn--loading")),
          (event.persisted ||
            ("undefined" != typeof window.performance &&
              window.performance.navigation &&
              2 === window.performance.navigation.type)) &&
            theme.resetScrollPosition();
      }),
      (theme.initSecondary = function () {
        document.body.classList.add("js-animate"),
          AOS.init({
            easing: "ease-out-quad",
            once: !1,
            mirror: !0,
            offset: 100,
            disableMutationObserver: !0,
          }),
          document.addEventListener("lazyloaded", function (e) {
            var i = t(e.target);
            i.length && i.parent().addClass("loaded");
          }),
          document.dispatchEvent(new CustomEvent("page:loaded")),
          theme.storeScrollPositionOnUnload(),
          theme.reviewAppLinkListener(),
          theme.checkForAnchorLink();
      }),
      (theme.storeScrollPositionOnUnload = function () {
        if (theme.config.hasSessionStorage) {
          var e = theme.config.isSafari ? "pagehide" : "beforeunload";
          window.addEventListener(e, function (e) {
            var i = t(document).scrollTop();
            sessionStorage.setItem(
              "scrollPosition_" + document.location.pathname,
              i.toString()
            );
          });
        }
      }),
      (theme.resetScrollPosition = function () {
        if (theme.config.hasSessionStorage) {
          var e = document.location.pathname;
          sessionStorage["scrollPosition_" + e] &&
            t(document).scrollTop(
              sessionStorage.getItem("scrollPosition_" + e)
            );
        }
      });
    (theme.reviewAppLinkListener = function () {
      t("body").on("click", ".spr-pagination", function () {
        var e = t(this).closest(".spr-reviews").scrollLeft(0);
      });
    }),
      (theme.checkForAnchorLink = function () {
        if (window.location.hash) {
          var t = document.querySelector(window.location.hash);
          t && window.scrollTo(0, t.offsetTop - 100);
        }
      }),
      (theme.reinitProductGridItem = function () {
        AOS && AOS.refreshHard(),
          window.SPR && (SPR.initDomEls(), SPR.loadBadges()),
          theme.collapsibles.init();
      }),
      t(document).ready(function () {
        theme.init(),
          theme.utils.promiseStylesheet().then(function () {
            theme.initSecondary();
          }),
          (window.sections = new theme.Sections()),
          sections.register("header-section", theme.HeaderSection),
          sections.register("slideshow-section", theme.SlideshowSection),
          sections.register("hero-animated", theme.HeroAnimated),
          sections.register("video-section", theme.VideoSection),
          sections.register("product", theme.Product),
          sections.register("product-recommendations", theme.Recommendations),
          sections.register("product-template", theme.Product),
          sections.register("featured-collection", theme.FeaturedCollection),
          sections.register("collection-template", theme.Collection),
          sections.register("collection-filter", theme.CollectionFilter),
          sections.register(
            "featured-content-section",
            theme.FeaturedContentSection
          ),
          sections.register("testimonials", theme.Testimonials),
          sections.register("newsletter-popup", theme.NewsletterPopup),
          sections.register("map", theme.Maps),
          sections.register("blog", theme.Blog),
          sections.register("footer-section", theme.FooterSection);
      });
  })(theme.jQuery);
//# sourceMappingURL=/s/files/1/0470/0333/6854/t/16/assets/theme.js.map?v=1629345156
document.addEventListener("cart:updated", function (evt) {
  var cart = evt.detail.cart;
  var freeDiscount = $("#freeShippingAmount").val();
  var freeShipAmount = $("#freeShippingAmount2").val();
  var success_text_2 = $("#success_text_2").val();
  var success_text = $("#success_text").val();
  var offer_text = $("#offer_text").val();
  if (cart.original_total_price < freeDiscount) {
    if (cart.original_total_price < freeShipAmount) {
      $(".free-shipping-text").text(offer_text);
    } else {
      $(".free-shipping-text").text(success_text);
    }
    if (cart.original_total_price > 0) {
      var remainAmount = (
        (freeDiscount - cart.original_total_price) /
        100
      ).toFixed(2);
      var percentage = (cart.original_total_price * 100) / freeDiscount;
      $(".free-shipping-content .inner-bar").css("width", percentage + "%");
    } else {
      $(".free-shipping-content").hide();
    }
    $(".cart-bottom-original").hide();
  } else {
    $(".free-shipping-text").text(success_text_2);
    $(".free-shipping-content .inner-bar").css("width", "100%");
    if (cart.original_total_price != cart.total_price) {
      $(".cart-bottom-original").show();
    }
  }
  var productH = cart.items[0].handle;
  $.ajax({
    type: "GET",
    url: "/products/" + productH + "?view=upsells",
    success: function (t) {
      var p = $(t).find("#ProductCollections").html();
      var c = $(t).find(".upsell-product").length;
      console.log(c);
      if (c == 0) {
        $(".upsell-products").hide();
        $(".upsell-products .upsell-head").hide();
      } else {
        $(".upsell-products").css("display", "flex");
        $(".upsell-products .upsell-head").show();
        $(".upsell-products .product-list").html(p);
      }
    },
    dataType: "html",
  });
});
$(document).ready(function (t, e) {
  $(document).on("click", ".cart_qty_control", function () {
    var qty = parseInt(
      $(this).parents(".cart_quantity_container").find(".cart__quantity").val()
    );
    if (qty > 0) {
      if ($(this).hasClass("down")) {
        qty = qty - 1;
      } else {
        if ($(this).hasClass("up")) {
          qty = qty + 1;
        }
      }
    }
    $(this)
      .parents(".cart_quantity_container")
      .find(".cart__quantity")
      .val(qty)
      .trigger("change");
  });
  $(document).on(
    "click",
    ".button-with-qty .qty-selector span.qty-btn",
    function (e) {
      e.preventDefault();
      var qty = parseInt(
        $(this).parents(".qty-selector").find(".qty-number").val()
      );
      if ($(this).hasClass("minu-btn")) {
        if (qty > 1) {
          qty = qty - 1;
        }
      } else {
        if ($(this).hasClass("plus-btn")) {
          qty = qty + 1;
        }
      }
      $(this)
        .parents(".qty-selector")
        .find(".qty-number")
        .val(qty)
        .trigger("change");
    }
  );
  $("button.pp-btn").click(function () {
    $(this).toggleClass("pause");
    $(".animation-wrapper").toggleClass("pause-animation");
  });
  $.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };
  $(window).on("scroll", function () {
    if ($(window).width() < 899) {
      if($(".product__photos").length > 0){
        if (
          $(".product__photos").isInViewport() ||
          $(".gallery").isInViewport() ||
          $(".product-single__form").isInViewport()
        ) {
          $(".button-with-qty").removeClass("fixed-btn");
        } else {
          $(".button-with-qty").addClass("fixed-btn");
        }
      }
    }
  });
});
$(document).ready(function () {
  $(".gallery-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: false,
    infinite: false,
    arrows: false,
    adaptiveHeight: true,
  });
  $(".gallery-thumbs .product__thumb-item .product__thumb").click(function (e) {
    e.preventDefault();
    $(".product__thumb-item .product__thumb").addClass("pointernone");
    var slideno = $(this).data("slideindex");
    $(".gallery-slider").slick("slickGoTo", slideno - 1);
  });
  $(".gallery-slider").on("afterChange", function (e, s, currentSlideIndex) {
    var currentIndex =
      parseInt(
        $(".gallery-slider .product__slide.slick-active").attr(
          "data-slick-index"
        )
      ) + 1;
    console.log(currentIndex);
    $(".product__thumb-item .product__thumb").removeClass("active");
    $(".product_thumb_" + currentIndex + " .product__thumb").addClass("active");
    $(".product__thumb-item .product__thumb").removeClass("pointernone");
  });
  $("span.sidebar-opener").click(function (e) {
    e.preventDefault();
    var ajaxurl = $(this).data("href");
    $.ajax({
      type: "GET",
      url: ajaxurl,
      success: function (t) {
        var p = $(t).find(".main-content").html();
        $(".sidebar-link .link-content-area").html(p);
        $(".sidebar-link").addClass("show");
        $("body").addClass("overflow-fixed");
        $("html").addClass("overflow-fixed");
      },
      dataType: "html",
    });
  });
  $(".sidebar-overlay").click(function (e) {
    $(".sidebar-link").removeClass("show");
    $("body").removeClass("overflow-fixed");
    $("html").removeClass("overflow-fixed");
  });

  $(".review-popup-overlay").click(function (e) {
    $(".review-popup").hide();
    $("body").removeClass("overflow-fixed");
    $("html").removeClass("overflow-fixed");
  });
  $("button.review-qa-button-trggier.review-trigger").click(function () {
    $(".review-popup").show();
    $("body").addClass("overflow-fixed");
    $("html").addClass("overflow-fixed");
  });
  $(".qa-popup-overlay").click(function (e) {
    $(".qa-popup").hide();
    $("body").removeClass("overflow-fixed");
    $("html").removeClass("overflow-fixed");
  });
  $("button.review-qa-button-trggier.qa-trigger").click(function () {
    $(".qa-popup").show();
    $("body").addClass("overflow-fixed");
    $("html").addClass("overflow-fixed");
  });
});

$(document).ready(function () {
  if ($(".banner-after-grid").length > 0) {
    var newh1 = $(".grid-product").height();
    var newh = $(".grid-product").height() - 30;
    $(".banner-after-grid").height(newh);
  }
  $(".cart__note label").click(function (e) {
    $(".cart__note textarea").toggle();
    $("#CartDrawer").toggleClass("cart_note_active");
  });
  $(".quick-view-close-trigger").click(function () {
    $(".quick-view-box").hide();
    $("body").removeClass("overflow-fixed");
    $("html").removeClass("overflow-fixed");
  });
  $(".quick-view-overlay").click(function () {
    $(".quick-view-box").hide();
    $("body").removeClass("overflow-fixed");
    $("html").removeClass("overflow-fixed");
  });
  $("button.quick-product__btn").click(function () {
    var urlhalf = $(this).data("url");
    var url = $(this).data("url") + "?view=quick-view";
    $.ajax({
      type: "GET",
      url: url,
      success: function (t) {
        var p = $(t).find(".quickviewproduct").html();
        console.log(p);
        $(".quick-view-box .quick-view-product").html(p);
        $(".quick-view-box").css("display", "flex");
        $(".fullview").attr("href", urlhalf);
        $("body").addClass("overflow-fixed");
        $("html").addClass("overflow-fixed");
        $(".quick-view-box .gallery-slider").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: false,
          infinite: false,
          arrows: false,
          adaptiveHeight: true,
        });
        $(
          ".quick-view-box .gallery-thumbs .product__thumb-item .product__thumb"
        ).click(function (e) {
          e.preventDefault();
          $(".quick-view-box.product__thumb-item .product__thumb").addClass(
            "pointernone"
          );
          var slideno = $(this).data("slideindex");
          $(".quick-view-box .gallery-slider").slick("slickGoTo", slideno - 1);
        });
        $(".quick-view-box .gallery-slider").on(
          "afterChange",
          function (e, s, currentSlideIndex) {
            var currentIndex =
              parseInt(
                $(
                  ".quick-view-box .gallery-slider .product__slide.slick-active"
                ).attr("data-slick-index")
              ) + 1;
            console.log(currentIndex);
            $(
              ".quick-view-box .product__thumb-item .product__thumb"
            ).removeClass("active");
            $(
              ".quick-view-box .product_thumb_" +
                currentIndex +
                " .product__thumb"
            ).addClass("active");
            $(
              ".quick-view-box .product__thumb-item .product__thumb"
            ).removeClass("pointernone");
          }
        );
      },
    });
  });
  var interval = setInterval(function () {
    console.log("rc notfound");
    if ($(".product-single__form .rc_widget").length) {
      console.log("rc found");
      var toggleElement = `<div class="toggle_subs_wrap">
      <input id="toggle_subs" type="checkbox" style="display:none;"/>
      <label for="toggle_subs" class="toggle_button_ui"></label>
      </div>`;
      $(".toggle_subs_wrap").remove();
      $(".product-single__form .rc_widget").append(toggleElement);
      var options = "";
      $(".product-single__form [data-plans-dropdown] option").each(function () {
        var $option = $(this);
        options += `<option value="${$option.attr(
          "value"
        )}">${$option.html()}</option>`;
      });
      var plan_select = `<select class="custom_plans" style="display: none;">${options}</select>`;
      $(".custom_plans").remove();
      $(".product-single__form [data-option-subsave]").append(plan_select);
      clearInterval(interval);
    }
  }, 100);
  setTimeout(function () {
    clearInterval(interval);
  }, 15000);

  $(document).on("change", "#toggle_subs", function () {
    var $el = $(this),
      $wrap = $el.closest(".toggle_subs_wrap");
    var $sub_radio = $('.rc-radio__input[value="subsave"]'),
      $one_radio = $('.rc-radio__input[value="onetime"]');
    if ($el.prop("checked")) {
      $sub_radio.click();
    } else {
      $one_radio.click();
    }
  });

  $(document).on("change", ".custom_plans", function () {
    var $el = $(this), val = $el.val();
    console.log(val,' >>>>>><<<<')
    $(".product-single__form [data-plans-dropdown]")
      .val(val)
      .change();
  });

  $(document).on("change", ".rc_widget__option__input", function () {
    var $active_radio = $(
        '[data-section-type="product-template"] .rc_widget__option__input:checked'
      ),
      val = $active_radio.val(),
      $custom_plans = $(".custom_plans");
    $("#toggle_subs").prop("checked", val == "subsave");
    if (val == "subsave") {
      $custom_plans.show();
    } else {
      $custom_plans.hide();
    }
  });
  
}); // ready



